<template>
  <div class='mt-1'>
    <section>
      <tab-buttons />
    </section>

    <b-overlay
      :show='lookingForCompany'
      rounded
      no-center
      opacity='0.6'
      spinner-small
      spinner-variant='primary'
      class='d-inline-block w-100'
      style='min-height: 250px'
    >
      <Unit
        :unitId='unitId'
        :companyId='companyId'
        @update='getCompany'
      >
      </Unit>

      <modal-confirm-action
        variant='danger'
        refModal='deleteUnit'
        idModal='deleteUnit'
        :loading='loadingRemove'
        :description='descriptionRemove'
        :title='titleRemove'
        @confirmed='deleteUnit'
      />

      <Sector
        :unitId='unitId'
        :sectorId='sectorId'
        @update='getCompany'
      >
      </Sector>

      <modal-confirm-action
        variant='danger'
        refModal='deleteSector'
        idModal='deleteSector'
        :loading='loadingRemove'
        :description='descriptionRemove'
        :title='titleRemove'
        @confirmed='deleteSector'
      />

      <Role
        :roleId='roleId'
        :sectorId='sectorId'
        @update='getCompany'
      >
      </Role>

      <modal-confirm-action
        variant='danger'
        refModal='archiveRole'
        idModal='archiveRole'
        :loading='loadingRemove'
        :description='descriptionRemove'
        :title='titleRemove'
        @confirmed='archiveRole'
      />

      <Products
        :roleId='roleId'
        :lisProductsId='lisProductsId'
        :legalsearchIds='legalsearchIds'
        :sectorId='sectorId'
        :sectorRoleId='sectorRoleId'
        @update='getCompany'
      ></Products>

      <SelectRoles
        :sectorId='sectorId'
        @update='getCompany'
      >
      </SelectRoles>

      <ArchivedRoles
        :sectorId='archivedRolesSectorId'
        @update='getCompany'
      >
      </ArchivedRoles>

      <TermsOfUse
        :productId='productId'
        :productHierarchyId='productHierarchyId'
        :termsOfUseId='termsOfUseId'
        @update='getCompany'
      >
      </TermsOfUse>

      <b-modal
        ref='companyUpdate'
        id='companyUpdate'
        hide-footer
        header-bg-variant='info'
        header-text-variant='light'
        title='Atualizar empresa'
        size='lg'
      >
        <b-overlay
          :show='lookingForCompany'
          rounded
          opacity='0.6'
          spinner-small
          spinner-variant='primary'
          class='d-inline-block w-100'
          style='min-height: 250px'
        >
          <section class='modal-font-family' v-if='currentCompany'>
            <section>
              <label>Nome</label>
              <base-input-text
                v-model='company.name'
                placeholder='Digite o nome da empresa'
                class='label-input-modal'
                type='text'
              />
            </section>

            <section class='mt-3'>
              <label>Descrição da empresa</label>
              <base-text-area
                v-model='company.description'
                class='custom-textarea'
                placeholder='Digite a descrição da empresa'
                type='text'
              />
            </section>

            <section class='d-flex justify-content-between mt-4'>
              <base-button
                class='w-50 mr-3 btn-cancel'
                @click='hideModalCompanyUpdate()'
              >
                <span>Cancelar</span>
              </base-button>

              <b-overlay
                :show='loading'
                rounded
                opacity='0.6'
                spinner-small
                spinner-variant='primary'
                class='d-inline-block w-50'
              >
                <base-button
                  :disabled='disabled'
                  class='w-100 btn-add d-flex align-items-center justify-content-center'
                  @click='update()'
                >
                  <span class='mr-2'> Atualizar </span>
                </base-button>
              </b-overlay>
            </section>
          </section>

          <template v-slot:overlay>
            <div class='text-center loading-spinner'>
              <b-spinner
                style='width: 2rem; height: 2rem'
                variant='primary'
                label='Large Spinner'
              ></b-spinner>
              <h5 class='text-primary'>Buscando empresa...</h5>
            </div>
          </template>
        </b-overlay>
      </b-modal>

      <AgentPercentage
        :productId='productId'
        @update-agents='getCompany'
      >
      </AgentPercentage>

      <WorkersModal
        :sectorRoleId='sectorRoleId'
        @update='getCompany'
      >
      </WorkersModal>

      <QuantityUsedFrequencyExposureTimeUseModal
        :productId='productId'
        :productHierarchyId='productHierarchyId'
        :termsOfUseId='termsOfUseId'
        @update='getCompany'
      ></QuantityUsedFrequencyExposureTimeUseModal>

      <VentilationInstalledSpecificallyForTheProductionProcessModal
        :productId='productId'
        :termsOfUseId='termsOfUseId'
        @update='getCompany'
      ></VentilationInstalledSpecificallyForTheProductionProcessModal>

      <TemperatureModal
        :productId='productId'
        :termsOfUseId='termsOfUseId'
        @update='getCompany'
      >
      </TemperatureModal>

      <ImportTermsOfUse
        :targetProduct='importTargetProduct'
        :companyLegalConsultation='companyLegalConsultation'
        @update='getCompany'
      >
      </ImportTermsOfUse>

      <VentilationIdentifiedModal
        :sectorId='sectorId'
        @update='getCompany'
      >
      </VentilationIdentifiedModal>

      <ProductAdd
        @clear-items-remove='getCompany'>
      </ProductAdd>

      <AnalysisToolModal
        :protecaoEficazProps='protecaoEficazProps'
        :functionalityProps='functionalityProps'
        :exposicaoPermanenteProps='exposicaoPermanenteProps'
        :userOrProduct='userOrProduct'
        :disabled='disabledAnalysisTool'
        @updatePermanentExhibition='updatePermanentExhibition'
        @updateEffectiveprotection='updateEffectiveprotection'
        @to-load='getCompany'
      />

      <EffectiveProtection
        :protecaoEficazProps='protecaoEficazProps'
        :questionsProps='questions'
        :disabled='disabledAnalysisTool'
        :sectorId='sectorId'
        :sectorRoleId='sectorRoleId'
        @updateEffectiveprotection='updateEffectiveprotection'
        @to-load='getCompany'
      ></EffectiveProtection>

      <PermanentExhibition
        :disabled='disabledAnalysisTool'
        :productHierarchyId='productHierarchyId'
        :exposicaoPermanenteProps='exposicaoPermanenteProps'
        @updatePermanentExhibition='updatePermanentExhibition'
        @to-load='getCompany'
      ></PermanentExhibition>

      <Measurements
        :sectorRoleId='sectorRoleId'
        :legalSearches='legalSearches'
        @update='getCompany'
      />

      <UnlinkProductModal
        :product="product"
        :role="role"
        @update='getCompany'
      >
      </UnlinkProductModal>

      <section v-if="newCompanyHierarchyFormat">
        <section class='container-pendencies pl-2 pt-2 mb-3 d-flex align-items-center' v-if='pendencies.length > 0 || pendenciesSector.length > 0 || pendenciesRole.length > 0'>
          <section class='mr-2'>
            <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24' fill='none'>
              <path
                d='M11 17H13V11H11V17ZM12 9C12.2833 9 12.521 8.904 12.713 8.712C12.905 8.52 13.0007 8.28267 13 8C13 7.71667 12.904 7.479 12.712 7.287C12.52 7.095 12.2827 6.99933 12 7C11.7167 7 11.479 7.096 11.287 7.288C11.095 7.48 10.9993 7.71733 11 8C11 8.28333 11.096 8.521 11.288 8.713C11.48 8.905 11.7173 9.00067 12 9ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6867 5.825 19.9743 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26333 14.6833 2.00067 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31333 6.88333 4.02567 5.825 4.925 4.925C5.825 4.025 6.88333 3.31267 8.1 2.788C9.31667 2.26333 10.6167 2.00067 12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31333 18.175 4.02567 19.075 4.925C19.975 5.825 20.6877 6.88333 21.213 8.1C21.7383 9.31667 22.0007 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6867 17.1167 19.9743 18.175 19.075 19.075C18.175 19.975 17.1167 20.6877 15.9 21.213C14.6833 21.7383 13.3833 22.0007 12 22Z'
                fill='#CD0000' />
            </svg>
          </section>

          <section>
            <section v-for='(pendency, index) in pendenciesSector' :key="`${pendency.sectorId}_${index}`">
              <section v-for='(field , indexField) in pendency.fieldsNotFilledIn' class='mb-1' :key="`${pendency.sectorId}_${field}_${index}_${indexField}`">
                <b-button
                  variant='success'
                  class='mr-2'
                  @click='completeHierarchySector(pendency.sectorId)'
                >
                  Preencher
                </b-button>

                <span class='item'>
                  <span>Há ações pendentes no item </span>
                  <strong>"{{ field }}"</strong>
                  do setor
                  <strong>"{{ pendency.sector }}"</strong>
                </span>
              </section>
            </section>

            <section v-for='(pendency, index) in pendenciesRole' :key="`${pendency.sectorRoleId}_${index}`">
              <section v-for='(field , indexField) in pendency.fieldsNotFilledIn' class='mb-1' :key="`${pendency.sectorRoleId}_${field}_${index}_${indexField}`">
                <b-button
                  variant='success'
                  class='mr-2'
                  @click='completeHierarchySector(pendency.sectorRoleId)'
                >
                  Preencher
                </b-button>

                <span class='item'>
                  <span>Há ações pendentes no item </span>
                  <strong>"{{ field }}"</strong>
                  do cargo
                  <strong>"{{ pendency.sectorRole }}"</strong>
                </span>
              </section>
            </section>

            <section v-for='(pendency, index) in pendencies' :key="`${pendency.productId}_${index}`">
              <section v-for='(field, indexField) in pendency.fieldsNotFilledIn' class='mb-1' :key="`${pendency.productId}_${field}_${index}_${indexField}`">
                <b-button
                  variant='success'
                  class='mr-2'
                  @click='completeHierarchy(pendency.productId)'
                >
                  Preencher
                </b-button>

                <span class='item'>
                  <span>Há ações pendentes no item </span>
                  <strong>"{{ field }}"</strong>
                  do produto
                  <strong>"{{ pendency.product }}"</strong>
                </span>
              </section>
            </section>

            <p class='item mt-2'>Finalize o preenchimento dos itens para continuar.</p>
          </section>
        </section>

        <section class='mt-1 mb-5' v-if='companyLegalConsultation'>
          <section :id='companyLegalConsultation._id'>
            <section
              class='company d-flex align-items-center justify-content-between'
              @click='detailCompany(companyLegalConsultation)'
            >
              <section class='d-flex align-items-center justify-content-start h-100'>
                <span class='name ml-3'>Empresa: {{ companyLegalConsultation.name }}</span>
              </section>

              <section class='d-flex align-items-center justify-content-between mr-3'>
                <section class='mr-2'>
                  <b-dropdown
                    right
                    class='mr-2 btn-options'
                    menu-class='options'
                    variant='outline-dange'
                    no-flip
                    no-caret
                  >
                    <template #button-content>
                      <strong class='btn-options-text'>Opções</strong>
                    </template>
                    <b-dropdown-item
                      @click='showModalUnit(companyLegalConsultation, $event)'
                      class='d-flex align-items-center dropdown-item-add'
                    >
                      <svg width='18' height='18' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M10 2C14.411 2 18 5.589 18 10C18 14.411 14.411 18 10 18C5.589 18 2 14.411 2 10C2 5.589 5.589 2 10 2ZM10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM15 9H11V5H9V9H5V11H9V15H11V11H15V9Z'
                          fill='#262626' />
                      </svg>

                      <span class='ml-2 dropdown-item-add-text'>Adicionar uma nova unidade a empresa</span>
                    </b-dropdown-item>

                    <b-dropdown-divider class='mx-3'></b-dropdown-divider>

                    <b-dropdown-item
                      @click='showModalEditCompany(companyLegalConsultation, $event)'
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                      >
                        <path
                          d='M13 3C13.2549 3.00028 13.5 3.09788 13.6854 3.27285C13.8707 3.44782 13.9822 3.68695 13.9972 3.94139C14.0121 4.19584 13.9293 4.44638 13.7657 4.64183C13.6021 4.83729 13.3701 4.9629 13.117 4.993L13 5H5V19H19V11C19.0003 10.7451 19.0979 10.5 19.2728 10.3146C19.4478 10.1293 19.687 10.0178 19.9414 10.0028C20.1958 9.98789 20.4464 10.0707 20.6418 10.2343C20.8373 10.3979 20.9629 10.6299 20.993 10.883L21 11V19C21.0002 19.5046 20.8096 19.9906 20.4665 20.3605C20.1234 20.7305 19.6532 20.9572 19.15 20.995L19 21H5C4.49542 21.0002 4.00943 20.8096 3.63945 20.4665C3.26947 20.1234 3.04284 19.6532 3.005 19.15L3 19V5C2.99984 4.49542 3.19041 4.00943 3.5335 3.63945C3.87659 3.26947 4.34684 3.04284 4.85 3.005L5 3H13ZM19.243 3.343C19.423 3.16365 19.6644 3.05953 19.9184 3.05177C20.1723 3.04402 20.4197 3.13322 20.6103 3.30125C20.8008 3.46928 20.9203 3.70355 20.9444 3.95647C20.9685 4.2094 20.8954 4.46201 20.74 4.663L20.657 4.758L10.757 14.657C10.577 14.8363 10.3356 14.9405 10.0816 14.9482C9.82767 14.956 9.58029 14.8668 9.38972 14.6988C9.19916 14.5307 9.07969 14.2964 9.0556 14.0435C9.03151 13.7906 9.10459 13.538 9.26 13.337L9.343 13.243L19.243 3.343Z'
                          fill='#262626'
                        />
                      </svg>

                      <span class='ml-2 dropdown-item-add-text'>Editar Empresa</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </section>

                <section>
                  <b-popover
                    custom-class=''
                    :target="`${companyLegalConsultation._id}_hover`"
                    placement='top'
                    triggers='hover'
                  >
                  <span v-if='companyLegalConsultation.open'>
                    Clique para ocultar as informações da empresa: <strong>{{companyLegalConsultation.name}}</strong>
                  </span>
                    <span v-else>
                    Clique para expandir as informações da empresa: <strong>{{companyLegalConsultation.name}}</strong>
                  </span>
                  </b-popover>

                  <button
                    :id="`${companyLegalConsultation._id}_hover`"
                    class='pointer btn-expand-collapse-white'
                    :class="companyLegalConsultation.open ? '' : 'pulse-gro-chevron-up'"
                  >
                    <span>{{companyLegalConsultation.open ? 'Recolher informações' : 'Expandir informações'}}</span>
                  </button>
                </section>
              </section>
            </section>

            <section
              class='body-hierarchy'
              v-if='!companyLegalConsultation.units || companyLegalConsultation.units.length === 0'
            >
              <button
                class='btn-add-hierarchy'
                @click='showModalUnit(companyLegalConsultation, $event)'
              >
                <b-icon
                  class='body-hierarchy-icon'
                  font-scale='1.4'
                  icon='plus-circle-fill'
                >
                </b-icon>
                <span>
                Clique para adicionar uma nova unidade a empresa
              </span>
              </button>
            </section>
          </section>

          <section class='transition' v-if='companyLegalConsultation.open'>
            <section v-for='unit in companyLegalConsultation.units' :key='unit._id'>
              <section style='margin-left: 25px' :id='unit._id'>
                <section
                  class='unit d-flex align-items-center justify-content-between'
                  @click='detailUnit(unit._id)'
                >
                  <section class='d-flex align-items-center justify-content-start h-100'>
                    <span class='name ml-3'>Unidade: {{ unit.name }}</span>
                  </section>

                  <section class='d-flex align-items-center justify-content-between mr-3'>
                    <section class='mr-2'>
                      <b-dropdown
                        right
                        class='mr-2 btn-options'
                        menu-class='options'
                        variant='outline-dange'
                        no-flip
                        no-caret
                      >
                        <template #button-content>
                          <strong class='btn-options-text'>Opções</strong>
                        </template>

                        <b-dropdown-item
                          @click='showModalSector(unit, $event)'
                          class='d-flex align-items-center dropdown-item-add'
                        >
                          <svg width='18' height='18' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path
                              d='M10 2C14.411 2 18 5.589 18 10C18 14.411 14.411 18 10 18C5.589 18 2 14.411 2 10C2 5.589 5.589 2 10 2ZM10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM15 9H11V5H9V9H5V11H9V15H11V11H15V9Z'
                              fill='#262626' />
                          </svg>

                          <span class='ml-2 dropdown-item-add-text'>Adicionar um novo setor a unidade</span>
                        </b-dropdown-item>
                        <b-dropdown-divider class='mx-3'></b-dropdown-divider>

                        <b-dropdown-item
                          @click='showModalUpdateUnit(unit, $event)'
                        >
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <path
                              d='M13 3C13.2549 3.00028 13.5 3.09788 13.6854 3.27285C13.8707 3.44782 13.9822 3.68695 13.9972 3.94139C14.0121 4.19584 13.9293 4.44638 13.7657 4.64183C13.6021 4.83729 13.3701 4.9629 13.117 4.993L13 5H5V19H19V11C19.0003 10.7451 19.0979 10.5 19.2728 10.3146C19.4478 10.1293 19.687 10.0178 19.9414 10.0028C20.1958 9.98789 20.4464 10.0707 20.6418 10.2343C20.8373 10.3979 20.9629 10.6299 20.993 10.883L21 11V19C21.0002 19.5046 20.8096 19.9906 20.4665 20.3605C20.1234 20.7305 19.6532 20.9572 19.15 20.995L19 21H5C4.49542 21.0002 4.00943 20.8096 3.63945 20.4665C3.26947 20.1234 3.04284 19.6532 3.005 19.15L3 19V5C2.99984 4.49542 3.19041 4.00943 3.5335 3.63945C3.87659 3.26947 4.34684 3.04284 4.85 3.005L5 3H13ZM19.243 3.343C19.423 3.16365 19.6644 3.05953 19.9184 3.05177C20.1723 3.04402 20.4197 3.13322 20.6103 3.30125C20.8008 3.46928 20.9203 3.70355 20.9444 3.95647C20.9685 4.2094 20.8954 4.46201 20.74 4.663L20.657 4.758L10.757 14.657C10.577 14.8363 10.3356 14.9405 10.0816 14.9482C9.82767 14.956 9.58029 14.8668 9.38972 14.6988C9.19916 14.5307 9.07969 14.2964 9.0556 14.0435C9.03151 13.7906 9.10459 13.538 9.26 13.337L9.343 13.243L19.243 3.343Z'
                              fill='#262626'
                            />
                          </svg>

                          <span class='ml-2 dropdown-item-add-text'>Editar Unidade</span>
                        </b-dropdown-item>
                        <b-dropdown-divider class='mx-3'></b-dropdown-divider>

                        <b-dropdown-item
                          @click='showModalDeleteUnit(unit, $event)'
                        >
                          <svg
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              fill-rule='evenodd'
                              clip-rule='evenodd'
                              d='M9.94286 3.75C9.87466 3.75 9.80925 3.77634 9.76103 3.82322C9.71281 3.87011 9.68571 3.9337 9.68571 4V6.25H14.3143V4C14.3143 3.9337 14.2872 3.87011 14.239 3.82322C14.1907 3.77634 14.1253 3.75 14.0571 3.75H9.94286ZM15.8571 6.25V4C15.8571 3.53587 15.6675 3.09075 15.3299 2.76256C14.9924 2.43437 14.5345 2.25 14.0571 2.25H9.94286C9.46547 2.25 9.00763 2.43437 8.67006 2.76256C8.3325 3.09075 8.14286 3.53587 8.14286 4V6.25H4.80901C4.80359 6.24994 4.79816 6.24994 4.79271 6.25H3.77143C3.34538 6.25 3 6.58579 3 7C3 7.41421 3.34538 7.75 3.77143 7.75H4.09018L5.05735 19.0337C5.06637 19.7508 5.36332 20.4368 5.88561 20.9445C6.41607 21.4603 7.13553 21.75 7.88571 21.75H16.1143C16.8645 21.75 17.5839 21.4603 18.1144 20.9445C18.6367 20.4368 18.9336 19.7508 18.9426 19.0337L19.9098 7.75H20.2286C20.6546 7.75 21 7.41421 21 7C21 6.58579 20.6546 6.25 20.2286 6.25H19.2073C19.2018 6.24994 19.1964 6.24994 19.191 6.25H15.8571ZM5.63839 7.75L6.59733 18.9377C6.59911 18.9584 6.6 18.9792 6.6 19C6.6 19.3315 6.73546 19.6495 6.97658 19.8839C7.21769 20.1183 7.54472 20.25 7.88571 20.25H16.1143C16.4553 20.25 16.7823 20.1183 17.0234 19.8839C17.2645 19.6495 17.4 19.3315 17.4 19C17.4 18.9792 17.4009 18.9584 17.4027 18.9377L18.3616 7.75H5.63839ZM9.94286 10.25C10.3689 10.25 10.7143 10.5858 10.7143 11V17C10.7143 17.4142 10.3689 17.75 9.94286 17.75C9.51681 17.75 9.17143 17.4142 9.17143 17V11C9.17143 10.5858 9.51681 10.25 9.94286 10.25ZM14.0571 10.25C14.4832 10.25 14.8286 10.5858 14.8286 11V17C14.8286 17.4142 14.4832 17.75 14.0571 17.75C13.6311 17.75 13.2857 17.4142 13.2857 17V11C13.2857 10.5858 13.6311 10.25 14.0571 10.25Z'
                              fill='#CD0000'
                            />
                          </svg>

                          <span class='ml-2 dropdown-item-delete-text'>Excluir Unidade</span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </section>

                    <section>
                      <b-popover
                        custom-class=''
                        :target="`${unit._id}_hover`"
                        placement='top'
                        triggers='hover'
                      >
                        <span v-if='unit.open'>
                          Clique para ocultar as informações da unidade: <strong>{{unit.name}}</strong>
                        </span>
                              <span v-else>
                          Clique para expandir as informações da unidade: <strong>{{unit.name}}</strong>
                        </span>
                      </b-popover>

                      <button
                        :id="`${unit._id}_hover`"
                        class='pointer btn-expand-collapse-white'
                        :class="unit.open ? ' ' : 'pulse-gro-chevron-up'"
                      >
                        <span>{{unit.open ? 'Recolher informações' : 'Expandir informações'}}</span>
                      </button>
                    </section>
                  </section>
                </section>

                <section
                  class='body-hierarchy'
                  v-if='!unit.sectors || unit.sectors.length === 0'
                >
                  <button
                    @click='showModalSector(unit, $event)'
                  >
                    <b-icon
                      font-scale='1.4'
                      icon='plus-circle-fill'
                      class='body-hierarchy-icon'
                    >
                    </b-icon>
                    <span>
                    Clique para adicionar um novo setor a unidade
                  </span>
                  </button>
                </section>
              </section>

              <section class='transition' v-if='unit.open'>
                <section v-for='sector in unit.sectors' :key='sector._id'>
                  <section style='margin-left: 50px' :id='sector._id'>
                    <section
                      class='sector d-flex align-items-center justify-content-between'
                      @click='detailSector(sector._id)'
                    >
                      <section class='d-flex align-items-center justify-content-start h-100'>
                        <span class='name ml-3'>Setor: {{ sector.name }}</span>
                      </section>

                      <section class='d-flex align-items-center justify-content-between mr-3'>
                        <section class='d-flex align-items-center justify-content-end mr-2'>
                          <b-popover
                            custom-class=''
                            :target='`${sector._id}_effectiveProtection`'
                            placement='top'
                            triggers='hover'
                          >
                            <span
                              class='label'
                              v-if='sector.effectiveProtection && sector.effectiveProtection._id'
                            >
                              Clique para editar a proteção eficaz
                           </span>

                            <span
                              v-else
                              class='label'
                            >
                              Clique para cadastrar a proteção eficaz
                            </span>
                          </b-popover>
                          <button
                            :id='`${sector._id}_effectiveProtection`'
                            :class="sector.effectiveProtection && sector.effectiveProtection._id &&
                              analysisPermanentExposureAndEffectiveProtection.interactedEffectiveProtectionQuestionsPergunta_1_existeEquipamentoProtecaoColetivaAuxiliarControleRiscoQuimico(sector.effectiveProtection)
                              ? 'btn-completed-effective-protection-sector'
                              : 'btn-completed-effective-protection-sector-without-filling'"
                            @click="showEffectiveProtection(sector, sector._id, null, $event, ['pergunta_1_existeEquipamentoProtecaoColetivaAuxiliarControleRiscoQuimico'])"
                          >
                            <p class='image-effective-protection'></p>
                          </button>

                          <!--Condição de ventilação do ambiente de trabalho de forma geral-->
                          <b-popover
                            custom-class=''
                            :target='`${sector._id}_ventilationWorkEnvironmentGeneral`'
                            placement='top'
                            triggers='hover'
                          >
                                <span v-if='sector && sector._id' class='label'>
                                  Clique para editar a condição de ventilação do ambiente de trabalho de forma geral
                                </span>

                            <span v-else class='label'>
                                  Clique para cadastrar a condição de ventilação do ambiente de trabalho de forma geral
                                </span>
                          </b-popover>
                          <button
                            :id='`${sector._id}_ventilationWorkEnvironmentGeneral`'
                            :class="sector && sector._id && sector.ventilationWorkEnvironmentGeneral ? 'btn-termsofuses' : 'btn-termsofuses-not-filled'"
                            @click='showModalCentilationWorkEnvironmentGeneral(sector, $event)'
                          >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M19.3018 0C21.7319 0 23.7089 1.97705 23.709 4.40723V19.3018C23.709 21.7318 21.7325 23.7088 19.3027 23.709H4.40723C1.97705 23.7088 0.000220658 21.7324 0 19.3027V4.40723C4.46801e-05 1.97708 1.97708 4.46796e-05 4.40723 0H19.3018ZM11.7031 2C6.34434 2 2 6.34434 2 11.7031C2.00011 17.0618 6.34441 21.4062 11.7031 21.4062C17.0618 21.4061 21.4061 17.0618 21.4062 11.7031C21.4062 6.34441 17.0618 2.00011 11.7031 2ZM2.98438 19.9004C2.71257 19.9006 2.49229 20.1207 2.49219 20.3926C2.49219 20.6645 2.71251 20.8855 2.98438 20.8857C3.25645 20.8857 3.47754 20.6646 3.47754 20.3926C3.47743 20.1206 3.25638 19.9004 2.98438 19.9004ZM20.7188 19.9004C20.4469 19.9006 20.2267 20.1207 20.2266 20.3926C20.2266 20.6645 20.4469 20.8855 20.7188 20.8857C20.9908 20.8857 21.2119 20.6646 21.2119 20.3926C21.2118 20.1206 20.9908 19.9004 20.7188 19.9004ZM2.98438 2.49512C2.71257 2.49536 2.49229 2.71547 2.49219 2.9873C2.49219 3.25923 2.71251 3.48023 2.98438 3.48047C3.25645 3.48047 3.47754 3.25938 3.47754 2.9873C3.47743 2.71532 3.25638 2.49512 2.98438 2.49512ZM20.7188 2.49512C20.4469 2.49536 20.2267 2.71547 20.2266 2.9873C20.2266 3.25923 20.4469 3.48023 20.7188 3.48047C20.9908 3.48047 21.2119 3.25938 21.2119 2.9873C21.2118 2.71532 20.9908 2.49512 20.7188 2.49512Z" fill="#022245"/>
                              <path d="M4.00127 13.217C3.84874 11.8598 4.06239 10.4912 4.58874 9.28811C5.11192 8.08289 5.94202 7.04231 6.9552 6.28809C6.07163 7.19141 5.45044 8.30971 5.14749 9.48306C4.84111 10.6567 4.85613 11.8819 5.16487 13.001C5.25207 13.3171 5.06661 13.6441 4.75049 13.7312C4.43436 13.8184 4.10744 13.633 4.02024 13.3169C4.01207 13.2874 4.00628 13.2581 4.00285 13.2286L4.00127 13.217Z" fill="#022245" fill-opacity="0.56"/>
                              <path d="M13.6936 6.21993C14.6233 6.64643 15.4136 7.30872 15.9765 8.09955C16.5421 8.8896 16.8835 9.80558 16.9776 10.7221C16.6904 9.84615 16.1791 9.07375 15.5326 8.49023C14.8867 7.90461 14.1077 7.51104 13.3058 7.33743C12.9841 7.26788 12.78 6.9507 12.8495 6.62905C12.9191 6.30739 13.2363 6.10322 13.5579 6.17277C13.5998 6.18173 13.6398 6.19516 13.6775 6.21202L13.6936 6.21993Z" fill="#022245" fill-opacity="0.56"/>
                              <path d="M15.735 16.2459C14.9088 16.8637 13.9396 17.2422 12.9668 17.355C11.9936 17.4704 11.0179 17.3247 10.1641 16.958C11.0766 17.1361 12.0084 17.0634 12.839 16.7773C13.6712 16.493 14.398 15.9954 14.9397 15.3697C15.1551 15.121 15.5313 15.0942 15.78 15.3094C16.0287 15.5249 16.0556 15.9011 15.8404 16.1498C15.8124 16.1819 15.7819 16.2104 15.7495 16.2351L15.735 16.2459Z" fill="#022245" fill-opacity="0.56"/>
                              <path d="M14.3597 4.33126C15.6034 4.86656 16.6782 5.72036 17.4606 6.76094C18.2459 7.8002 18.7422 9.02229 18.905 10.2639C18.5489 9.06286 17.8829 7.98434 17.0164 7.15188C16.1513 6.31652 15.0875 5.73143 13.9716 5.44902C13.6537 5.36867 13.4613 5.0457 13.5417 4.72773C13.622 4.40976 13.945 4.21745 14.263 4.2978C14.2928 4.30544 14.3215 4.31492 14.3489 4.32651L14.3597 4.33126Z" fill="#022245" fill-opacity="0.56"/>
                              <path d="M17.0568 17.6321C15.9825 18.4751 14.7056 19.0128 13.4055 19.1977C12.1052 19.3861 10.7835 19.2269 9.60938 18.7615C10.8423 19.0383 12.1199 18.9788 13.2777 18.62C14.4371 18.2638 15.4716 17.6071 16.2614 16.7562C16.4846 16.5159 16.8602 16.502 17.1005 16.7248C17.3407 16.9479 17.3547 17.3236 17.1318 17.5639C17.111 17.5863 17.0892 17.6065 17.066 17.625L17.0568 17.6321Z" fill="#022245" fill-opacity="0.56"/>
                              <path d="M5.88979 12.9183C5.79864 11.8906 5.98595 10.8671 6.40139 9.98042C6.81472 9.09184 7.45145 8.33841 8.21226 7.80469C7.58106 8.48725 7.15324 9.3184 6.95987 10.1751C6.7644 11.0326 6.80576 11.9125 7.05313 12.702C7.15139 13.016 6.97673 13.3503 6.66272 13.4486C6.3487 13.5468 6.0144 13.3722 5.91613 13.0582C5.90349 13.0176 5.89532 12.9768 5.89137 12.9359L5.88979 12.9183Z" fill="#022245" fill-opacity="0.56"/>
                              <path d="M11.8574 2.85352C13.1491 2.85352 14.3951 3.12403 15.5605 3.65723C15.7581 3.74765 15.8453 3.98172 15.7549 4.17969L13.4971 9.12207C14.3438 9.64842 14.8938 10.5572 14.9609 11.5566L20.373 12.0742C20.5897 12.095 20.7489 12.2875 20.7285 12.5039C20.6076 13.7787 20.2184 14.9926 19.5732 16.1104C18.9274 17.2287 18.0707 18.1725 17.0264 18.915C16.8488 19.0415 16.6025 18.9996 16.4766 18.8223L13.3799 14.4736C12.916 14.7365 12.3967 14.874 11.8574 14.874C11.3406 14.874 10.8401 14.7477 10.3896 14.5049L7.23828 18.9307C7.16142 19.0386 7.04018 19.0966 6.91699 19.0967C6.83796 19.0967 6.75776 19.0727 6.68848 19.0234C5.64407 18.2809 4.78751 17.3372 4.1416 16.2188C3.49644 15.1012 3.10777 13.8873 2.98633 12.6123C2.96604 12.3958 3.12427 12.2035 3.34082 12.1826L8.74805 11.665C8.78129 10.6227 9.34102 9.66736 10.2188 9.12207L7.96289 4.17871C7.87241 3.98065 7.95918 3.74684 8.15723 3.65625C9.32182 3.12364 10.5669 2.85352 11.8574 2.85352ZM11.8906 9C10.2943 9 9 10.2943 9 11.8906C9.0001 13.4869 10.2943 14.7812 11.8906 14.7812C13.4867 14.781 14.7811 13.4868 14.7812 11.8906C14.7812 10.2944 13.4868 9.00021 11.8906 9Z" fill="#022245"/>
                              <path d="M11.7852 8.5C13.5961 8.50019 15.0693 9.97414 15.0693 11.7852C15.0694 13.596 13.5963 15.0691 11.7852 15.0693C9.97388 15.0693 8.50019 13.5961 8.5 11.7852C8.5 9.97376 9.97402 8.5 11.7852 8.5ZM11.7852 9.28809C10.4088 9.28809 9.28926 10.4079 9.28906 11.7842C9.28906 13.1606 10.409 14.2812 11.7852 14.2812C13.1611 14.2811 14.2811 13.1613 14.2812 11.7852C14.2812 10.4088 13.1615 9.28828 11.7852 9.28809Z" fill="#022245"/>
                              <path d="M10.2161 11.7634C10.2804 11.3335 10.5217 10.9615 10.8357 10.7437C11.1495 10.5216 11.5304 10.451 11.8555 10.5184C11.5278 10.5835 11.2609 10.7813 11.1147 11.0224C10.9654 11.2645 10.9385 11.5403 11.0051 11.7632C11.0697 11.9797 10.9467 12.2078 10.7298 12.2726C10.5133 12.3375 10.2852 12.2142 10.2204 11.9974C10.2027 11.9383 10.199 11.8788 10.2074 11.8216L10.2161 11.7634Z" fill="#022245"/>
                            </svg>
                          </button>
                        </section>
                        <section class='mr-2'>
                          <b-dropdown
                            right
                            class='mr-2 btn-options'
                            menu-class='options'
                            variant='outline-dange'
                            no-flip
                            no-caret
                          >
                            <template #button-content>
                              <strong class='btn-options-text'>Opções</strong>
                            </template>

                            <b-dropdown-item
                              @click='showModalRole(sector, $event)'
                              class='d-flex align-items-center dropdown-item-add'
                            >
                              <svg width='18' height='18' viewBox='0 0 20 20' fill='none'
                                   xmlns='http://www.w3.org/2000/svg'>
                                <path
                                  d='M10 2C14.411 2 18 5.589 18 10C18 14.411 14.411 18 10 18C5.589 18 2 14.411 2 10C2 5.589 5.589 2 10 2ZM10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM15 9H11V5H9V9H5V11H9V15H11V11H15V9Z'
                                  fill='#262626' />
                              </svg>

                              <span class='ml-2 dropdown-item-add-text'>Adicionar um novo cargo ao setor</span>
                            </b-dropdown-item>
                            <b-dropdown-divider class='mx-3'></b-dropdown-divider>

                            <b-dropdown-item
                              @click='showModalSelectRoles(sector, $event)'
                              class='d-flex align-items-center dropdown-item-add'
                            >
                              <svg width='18' height='18' viewBox='0 0 20 20' fill='none'
                                   xmlns='http://www.w3.org/2000/svg'>
                                <path
                                  d='M10 2C14.411 2 18 5.589 18 10C18 14.411 14.411 18 10 18C5.589 18 2 14.411 2 10C2 5.589 5.589 2 10 2ZM10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM15 9H11V5H9V9H5V11H9V15H11V11H15V9Z'
                                  fill='#262626' />
                              </svg>

                              <span class='ml-2 dropdown-item-add-text'>Vincular um cargo existente ao setor</span>
                            </b-dropdown-item>
                            <b-dropdown-divider class='mx-3'></b-dropdown-divider>

                            <b-dropdown-item
                              @click='showModalArchivedRoles(sector, $event)'
                              class='d-flex align-items-center dropdown-item-add'
                            >
                              <b-icon
                                icon='archive'
                                font-scale='1.2'
                                class='ml-1'
                                variant='dark'
                              >
                              </b-icon>

                              <span class='ml-2 dropdown-item-add-text'>Ver cargos arquivados</span>
                            </b-dropdown-item>
                            <b-dropdown-divider class='mx-3'></b-dropdown-divider>

                            <b-dropdown-item
                              @click='showModalUpdateSector(sector, $event)'
                            >
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='24'
                                height='24'
                                viewBox='0 0 24 24'
                                fill='none'
                              >
                                <path
                                  d='M13 3C13.2549 3.00028 13.5 3.09788 13.6854 3.27285C13.8707 3.44782 13.9822 3.68695 13.9972 3.94139C14.0121 4.19584 13.9293 4.44638 13.7657 4.64183C13.6021 4.83729 13.3701 4.9629 13.117 4.993L13 5H5V19H19V11C19.0003 10.7451 19.0979 10.5 19.2728 10.3146C19.4478 10.1293 19.687 10.0178 19.9414 10.0028C20.1958 9.98789 20.4464 10.0707 20.6418 10.2343C20.8373 10.3979 20.9629 10.6299 20.993 10.883L21 11V19C21.0002 19.5046 20.8096 19.9906 20.4665 20.3605C20.1234 20.7305 19.6532 20.9572 19.15 20.995L19 21H5C4.49542 21.0002 4.00943 20.8096 3.63945 20.4665C3.26947 20.1234 3.04284 19.6532 3.005 19.15L3 19V5C2.99984 4.49542 3.19041 4.00943 3.5335 3.63945C3.87659 3.26947 4.34684 3.04284 4.85 3.005L5 3H13ZM19.243 3.343C19.423 3.16365 19.6644 3.05953 19.9184 3.05177C20.1723 3.04402 20.4197 3.13322 20.6103 3.30125C20.8008 3.46928 20.9203 3.70355 20.9444 3.95647C20.9685 4.2094 20.8954 4.46201 20.74 4.663L20.657 4.758L10.757 14.657C10.577 14.8363 10.3356 14.9405 10.0816 14.9482C9.82767 14.956 9.58029 14.8668 9.38972 14.6988C9.19916 14.5307 9.07969 14.2964 9.0556 14.0435C9.03151 13.7906 9.10459 13.538 9.26 13.337L9.343 13.243L19.243 3.343Z'
                                  fill='#262626'
                                />
                              </svg>

                              <span class='ml-2 dropdown-item-add-text'>Editar Setor</span>
                            </b-dropdown-item>
                            <b-dropdown-divider class='mx-3'></b-dropdown-divider>

                            <b-dropdown-item
                              @click='showModalDeleteSector(sector, $event)'
                            >
                              <svg
                                width='24'
                                height='24'
                                viewBox='0 0 24 24'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  fill-rule='evenodd'
                                  clip-rule='evenodd'
                                  d='M9.94286 3.75C9.87466 3.75 9.80925 3.77634 9.76103 3.82322C9.71281 3.87011 9.68571 3.9337 9.68571 4V6.25H14.3143V4C14.3143 3.9337 14.2872 3.87011 14.239 3.82322C14.1907 3.77634 14.1253 3.75 14.0571 3.75H9.94286ZM15.8571 6.25V4C15.8571 3.53587 15.6675 3.09075 15.3299 2.76256C14.9924 2.43437 14.5345 2.25 14.0571 2.25H9.94286C9.46547 2.25 9.00763 2.43437 8.67006 2.76256C8.3325 3.09075 8.14286 3.53587 8.14286 4V6.25H4.80901C4.80359 6.24994 4.79816 6.24994 4.79271 6.25H3.77143C3.34538 6.25 3 6.58579 3 7C3 7.41421 3.34538 7.75 3.77143 7.75H4.09018L5.05735 19.0337C5.06637 19.7508 5.36332 20.4368 5.88561 20.9445C6.41607 21.4603 7.13553 21.75 7.88571 21.75H16.1143C16.8645 21.75 17.5839 21.4603 18.1144 20.9445C18.6367 20.4368 18.9336 19.7508 18.9426 19.0337L19.9098 7.75H20.2286C20.6546 7.75 21 7.41421 21 7C21 6.58579 20.6546 6.25 20.2286 6.25H19.2073C19.2018 6.24994 19.1964 6.24994 19.191 6.25H15.8571ZM5.63839 7.75L6.59733 18.9377C6.59911 18.9584 6.6 18.9792 6.6 19C6.6 19.3315 6.73546 19.6495 6.97658 19.8839C7.21769 20.1183 7.54472 20.25 7.88571 20.25H16.1143C16.4553 20.25 16.7823 20.1183 17.0234 19.8839C17.2645 19.6495 17.4 19.3315 17.4 19C17.4 18.9792 17.4009 18.9584 17.4027 18.9377L18.3616 7.75H5.63839ZM9.94286 10.25C10.3689 10.25 10.7143 10.5858 10.7143 11V17C10.7143 17.4142 10.3689 17.75 9.94286 17.75C9.51681 17.75 9.17143 17.4142 9.17143 17V11C9.17143 10.5858 9.51681 10.25 9.94286 10.25ZM14.0571 10.25C14.4832 10.25 14.8286 10.5858 14.8286 11V17C14.8286 17.4142 14.4832 17.75 14.0571 17.75C13.6311 17.75 13.2857 17.4142 13.2857 17V11C13.2857 10.5858 13.6311 10.25 14.0571 10.25Z'
                                  fill='#CD0000'
                                />
                              </svg>

                              <span class='ml-2 dropdown-item-delete-text'>Excluir setor</span>
                            </b-dropdown-item>
                          </b-dropdown>
                        </section>

                        <section>
                          <b-popover
                            custom-class=''
                            :target="`${sector._id}_hover`"
                            placement='top'
                            triggers='hover'
                          >
                            <span v-if='sector.open'>
                              Clique para ocultar as informações do setor: <strong>{{sector.name}}</strong>
                            </span>
                                <span v-else>
                              Clique para expandir as informações do setor: <strong>{{sector.name}}</strong>
                            </span>
                          </b-popover>

                          <button
                            :id="`${sector._id}_hover`"
                            class='pointer btn-expand-collapse-white'
                            :class="sector.open ? '' : 'pulse-gro-chevron-up'"
                          >
                            <span>{{sector.open ? 'Recolher informações' : 'Expandir informações'}}</span>
                          </button>
                        </section>
                      </section>
                    </section>

                    <section
                      class='body-hierarchy'
                      v-if='!sector.sectorRoles || sector.sectorRoles.length === 0'
                    >
                      <button
                        @click='showModalRole(sector, $event)'
                      >
                        <b-icon
                          font-scale='1.4'
                          icon='plus-circle-fill'
                          class='body-hierarchy-icon'
                        >
                        </b-icon>
                        <span>
                          Clique para adicionar um novo cargo ao setor
                        </span>
                      </button>

                      <button
                        @click='showModalSelectRoles(sector, $event)'
                      >
                        <b-icon
                          font-scale='1.4'
                          icon='link45deg'
                          class='body-hierarchy-icon'
                        >
                        </b-icon>
                        <span>
                          Clique para vincular um cargo existente ao setor
                        </span>
                      </button>
                    </section>
                  </section>

                  <section class='transition' v-if='sector && sector.open'>
                    <section v-for='sectorRole in sector.sectorRoles' :key='sectorRole._id'>
                      <section :id='sectorRole._id' style='margin-left: 75px'>
                        <section
                          class='role d-flex align-items-center justify-content-between'
                          @click='detailRole(sectorRole)'
                        >
                          <section class='d-flex align-items-center justify-content-start h-100'>
                            <span class='name ml-3'>Cargo: {{ sectorRole.role.name }}</span>
                          </section>

                          <section class='d-flex align-items-end justify-content-between mr-3'>
                            <section class="mr-2">
                              <!--Quantidade de trabalhadores expostos-->
                              <b-popover
                                custom-class=''
                                :target='`${sectorRole._id}_exposedWorkers`'
                                placement='top'
                                triggers='hover'
                              >
                                    <span class='label' v-if='sectorRole && sectorRole.exposedWorkers'>
                                      Clique para editar a quantidade de trabalhadores expostos
                                    </span>
                                <span v-else class='label'>
                                      Clique para cadastrar a quantidade de trabalhadores expostos
                                    </span>
                              </b-popover>
                              <button
                                :id='`${sectorRole._id}_exposedWorkers`'
                                :class="sectorRole && sectorRole.exposedWorkers ? 'btn-termsofuses' : 'btn-termsofuses-not-filled'"
                                @click="showModalExposedWorkers(sectorRole, $event)"
                              >
                                <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24'
                                     fill='none'>
                                  <path
                                    d='M16 9C16 14.33 8 14.33 8 9H10C10 11.67 14 11.67 14 9M20 18V21H4V18C4 15.33 9.33 14 12 14C14.67 14 20 15.33 20 18ZM18.1 18C18.1 17.36 14.97 15.9 12 15.9C9.03 15.9 5.9 17.36 5.9 18V19.1H18.1M12.5 2C12.78 2 13 2.22 13 2.5V5.5H14V3C14.7077 3.32752 15.3006 3.86019 15.7019 4.52889C16.1031 5.19758 16.294 5.97142 16.25 6.75C16.25 6.75 16.95 6.89 17 8H7C7 6.89 7.75 6.75 7.75 6.75C7.70595 5.97142 7.89693 5.19758 8.29814 4.52889C8.69936 3.86019 9.29229 3.32752 10 3V5.5H11V2.5C11 2.22 11.22 2 11.5 2'
                                    fill='#022245' />
                                </svg>
                              </button>

                              <!--Adição de medidas realizadas-->
                              <b-popover
                                custom-class=''
                                :target='`${sectorRole._id}_measurement`'
                                placement='top'
                                triggers='hover'
                              >
                                <span v-if='sectorRole && sectorRole.measurements && sectorRole.measurements.length > 0' class='label'>
                                  Clique para editar medições
                                </span>

                                <span v-else class='label'>
                                  Clique para cadastrar medições
                                </span>
                              </b-popover>
                              <button
                                :id='`${sectorRole._id}_measurement`'
                                :class="sectorRole && (sectorRole.measurements && sectorRole.measurements.length > 0 || sectorRole.noMeasurementsWillBeTaken) ? 'btn-termsofuses' : 'btn-termsofuses-not-filled'"
                                @click='showModalEditMeasurements(sectorRole, $event)'
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" class="bi bi-speedometer" viewBox="0 0 16 16">
                                  <path d="M8 2a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V2.5A.5.5 0 0 1 8 2M3.732 3.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707M2 8a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 8m9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5m.754-4.246a.39.39 0 0 0-.527-.02L7.547 7.31A.91.91 0 1 0 8.85 8.569l3.434-4.297a.39.39 0 0 0-.029-.518z"/>
                                  <path fill-rule="evenodd" d="M6.664 15.889A8 8 0 1 1 9.336.11a8 8 0 0 1-2.672 15.78zm-4.665-4.283A11.95 11.95 0 0 1 8 10c2.186 0 4.236.585 6.001 1.606a7 7 0 1 0-12.002 0"/>
                                </svg>
                              </button>

                              <!--proteção eficaz-->
                              <b-popover
                                custom-class=''
                                :target='`${sectorRole._id}_effectiveProtection`'
                                placement='top'
                                triggers='hover'
                              >
                                <span v-if='sectorRole && sectorRole.measurements && sectorRole.measurements.length > 0' class='label'>
                                  Clique para editar a proteção eficaz
                                </span>

                                <span v-else class='label'>
                                  Clique para cadastrar a proteção eficaz
                                </span>
                              </b-popover>
                              <button
                                :id='`${sectorRole._id}_effectiveProtection`'
                                :class="sectorRole && sectorRole.effectiveProtection &&
                                  sectorRole.effectiveProtection._id &&
                                  analysisPermanentExposureAndEffectiveProtection.interactedEffectiveProtectionQuestionsPergunta_2_empregadorOrganizacaoCumpreFazCumprirItensNR06TopicoPergunta_3_empregadoTrabalhadorCumpreTodosItensNR06Topico66(sectorRole.effectiveProtection)
                                  ? 'btn-termsofuses'
                                  : 'btn-termsofuses-not-filled'"
                                @click="showEffectiveProtection(sector, null, sectorRole._id, $event, ['pergunta_2_empregadorOrganizacaoCumpreFazCumprirItensNR06Topico', 'pergunta_3_empregadoTrabalhadorCumpreTodosItensNR06Topico66'])"
                              >
                                <svg width="24" height="25" viewBox="0 0 24 25" class="bi bi-speedometer"  xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" d="M13.4805 0.568359C13.7644 0.568359 13.9941 0.798705 13.9941 1.08203V5.06641C13.9941 5.34973 13.7644 5.58008 13.4805 5.58008H12.6104C12.0868 9.94847 12.61 12.7799 14.167 14.5576C15.563 16.1512 17.8732 16.957 21.3096 16.957C21.3107 16.957 21.3169 16.9577 21.3252 16.958H21.3262C22.0517 16.9808 22.6786 17.3568 23.1387 18.0078C23.6352 18.7107 23.9155 19.7037 24.0303 20.7109C24.0457 20.7431 24.0624 20.7784 24.0713 20.8193L24.0811 20.8936L24.0898 21.2109C24.0912 21.3218 24.0909 21.4373 24.0889 21.5557C24.1089 22.3889 24.0219 23.2072 23.835 23.875L23.834 23.874C23.8188 23.9337 23.8034 23.9924 23.7861 24.0469V24.0479C23.7182 24.2605 23.5204 24.4043 23.2969 24.4043H13.2666C13.0874 24.4042 12.9214 24.3113 12.8281 24.1582V24.1572C12.5191 23.647 11.9823 23.3448 11.3906 23.3447H8.08691C7.49535 23.3447 6.95875 23.6471 6.64941 24.1572V24.1582C6.55645 24.3111 6.38957 24.4043 6.20996 24.4043H1.32031C1.08797 24.4043 0.884383 24.2488 0.824219 24.0244C-0.0391866 20.7962 0.265884 18.0928 0.641602 14.7324C0.925662 12.1903 1.24274 9.33343 1.14746 5.58008H0.396484C0.112996 5.58008 -0.117188 5.34989 -0.117188 5.06641V1.08203C-0.117188 0.798543 0.112996 0.568359 0.396484 0.568359H13.4805ZM1.50586 21.4336C1.54708 22.0741 1.62109 22.8067 1.73145 23.3779H5.94043C6.45125 22.7097 7.23432 22.3174 8.08691 22.3174H11.3906C12.2428 22.3175 13.0258 22.7099 13.5361 23.3779H22.8936C22.9901 22.8758 23.0516 22.1635 23.0625 21.5439C23.0614 21.5071 23.0591 21.4704 23.0576 21.4336H1.50586ZM2.17578 5.58008C2.27098 9.3937 1.94801 12.2898 1.66211 14.8467C1.43348 16.8899 1.24199 18.6465 1.31543 20.4062H22.9521C22.8299 19.6851 22.6117 19.0422 22.2998 18.6006C22.0074 18.1866 21.6702 17.9972 21.2969 17.9844V17.9834C17.6403 17.9812 15.0307 17.102 13.3945 15.2344C11.6046 13.1905 11.0507 10.0847 11.5742 5.58008H2.17578ZM0.910156 4.55371H12.9668V1.5957H0.910156V4.55371Z"/>
                                </svg>
                              </button>
                            </section>
                            <section class='mr-2 mb-1'>
                              <b-dropdown
                                right
                                class='mr-2 btn-options'
                                menu-class='options'
                                variant='outline-dange'
                                no-flip
                                no-caret
                              >
                                <template #button-content>
                                  <strong class='btn-options-text'>Opções</strong>
                                </template>

                                <b-dropdown-item
                                  @click='showModalProducts(sectorRole, $event)'
                                  class='d-flex align-items-center dropdown-item-add'
                                >
                                  <svg width='18' height='18' viewBox='0 0 20 20' fill='none'
                                       xmlns='http://www.w3.org/2000/svg'>
                                    <path
                                      d='M10 2C14.411 2 18 5.589 18 10C18 14.411 14.411 18 10 18C5.589 18 2 14.411 2 10C2 5.589 5.589 2 10 2ZM10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM15 9H11V5H9V9H5V11H9V15H11V11H15V9Z'
                                      fill='#262626' />
                                  </svg>

                                  <span class='ml-2 dropdown-item-add-text'>Vincular produtos/riscos existentes ao cargo</span>
                                </b-dropdown-item>
                                <b-dropdown-divider class='mx-3'></b-dropdown-divider>

                                <b-dropdown-item
                                  @click='showModalUpdateRole(sectorRole.role, $event)'
                                >
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='24'
                                    height='24'
                                    viewBox='0 0 24 24'
                                    fill='none'
                                  >
                                    <path
                                      d='M13 3C13.2549 3.00028 13.5 3.09788 13.6854 3.27285C13.8707 3.44782 13.9822 3.68695 13.9972 3.94139C14.0121 4.19584 13.9293 4.44638 13.7657 4.64183C13.6021 4.83729 13.3701 4.9629 13.117 4.993L13 5H5V19H19V11C19.0003 10.7451 19.0979 10.5 19.2728 10.3146C19.4478 10.1293 19.687 10.0178 19.9414 10.0028C20.1958 9.98789 20.4464 10.0707 20.6418 10.2343C20.8373 10.3979 20.9629 10.6299 20.993 10.883L21 11V19C21.0002 19.5046 20.8096 19.9906 20.4665 20.3605C20.1234 20.7305 19.6532 20.9572 19.15 20.995L19 21H5C4.49542 21.0002 4.00943 20.8096 3.63945 20.4665C3.26947 20.1234 3.04284 19.6532 3.005 19.15L3 19V5C2.99984 4.49542 3.19041 4.00943 3.5335 3.63945C3.87659 3.26947 4.34684 3.04284 4.85 3.005L5 3H13ZM19.243 3.343C19.423 3.16365 19.6644 3.05953 19.9184 3.05177C20.1723 3.04402 20.4197 3.13322 20.6103 3.30125C20.8008 3.46928 20.9203 3.70355 20.9444 3.95647C20.9685 4.2094 20.8954 4.46201 20.74 4.663L20.657 4.758L10.757 14.657C10.577 14.8363 10.3356 14.9405 10.0816 14.9482C9.82767 14.956 9.58029 14.8668 9.38972 14.6988C9.19916 14.5307 9.07969 14.2964 9.0556 14.0435C9.03151 13.7906 9.10459 13.538 9.26 13.337L9.343 13.243L19.243 3.343Z'
                                      fill='#262626'
                                    />
                                  </svg>

                                  <span class='ml-2 dropdown-item-add-text'>Editar cargo</span>
                                </b-dropdown-item>
                                <b-dropdown-divider class='mx-3'></b-dropdown-divider>

                                <b-dropdown-item
                                  @click='showModalArchiveRole(sectorRole, unit, sector, $event)'
                                >
                                  <b-icon
                                    icon='archive'
                                    width='24'
                                    height='24'
                                    style='color: #262626'
                                  ></b-icon>

                                  <span class='ml-2 mb-2 dropdown-item-delete-text'>Arquivar cargo e informações dele neste setor</span>
                                </b-dropdown-item>
                              </b-dropdown>
                            </section>

                            <section class="mb-1" v-if="sectorRole && sectorRole.role && sectorRole.role.name">
                              <b-popover
                                custom-class=''
                                :target="`${sectorRole.role._id}_hover`"
                                placement='top'
                                triggers='hover'
                              >
                                <span v-if='sectorRole.role.open'>
                                  Clique para ocultar as informações do cargo: <strong>{{sectorRole.role.name}}</strong>
                                </span>
                                    <span v-else>
                                  Clique para expandir as informações do cargo: <strong>{{sectorRole.role.name}}</strong>
                                </span>
                              </b-popover>

                              <button
                                :id="`${sectorRole.role._id}_hover`"
                                class='pointer btn-expand-collapse-navy-blue'
                                :class="sectorRole.open ? ' ' : 'pulse-gro-chevron-up'"
                              >
                                <span>{{sectorRole.open ? 'Recolher informações' : 'Expandir informações'}}</span>
                              </button>
                            </section>
                          </section>
                        </section>
                        <section
                          class='body-hierarchy'
                          v-if='!sectorRole.role.roleProductsLegalConsultation || sectorRole.role.roleProductsLegalConsultation.length === 0'
                        >
                          <button
                            @click='showModalProducts(sectorRole, $event)'
                          >
                            <b-icon
                              font-scale='1.4'
                              icon='plus-circle-fill'
                              class='body-hierarchy-icon'
                            >
                            </b-icon>
                            <span>
                            Clique para vincular produtos/riscos existentes ao cargo
                          </span>
                          </button>
                        </section>
                      </section>
                      <section v-if="sectorRole && sectorRole.open">
                        <section class="risk-chemical">
                          <section class="risk-chemical-text">
                            <strong class="ml-3">Riscos Químicos</strong>
                          </section>
                          <section class="mr-3">
                            <button
                              :id="`${sectorRole.role._id}_hover`"
                              class='pointer btn-expand-collapse-navy-blue'
                              :class="sectorRole.chemicalRiskOpen ? ' ' : 'pulse-gro-chevron-up'"
                              @click="toggleRiskOpen(sectorRole, 'chemicalRiskOpen')"
                            >
                              <span>{{sectorRole.chemicalRiskOpen ? 'Recolher informações' : 'Expandir informações'}}</span>
                            </button>
                          </section>
                        </section>


                        <section class='transition' v-if='sectorRole.chemicalRiskOpen'>
                          <section
                            v-for='roleProduct in sectorRole.role.roleProductsLegalConsultation' :key='roleProduct._id'
                          >
                            <section
                              v-if="roleProduct && roleProduct.product && roleProduct.product._id"
                              :id='roleProduct.product._id'
                              class='product'
                              style='margin-left: 125px'
                            >
                              <section >
                                <section
                                  class='product d-flex align-items-center justify-content-between'
                                  style='background: #DADADA'
                                >
                                  <section class='d-flex align-items-center justify-content-start h-100'>
                                    <svg class="ml-3" width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M11 8V13.938L9.85801 14.48C8.83215 14.9664 8.00235 15.7874 7.5051 16.808C7.00785 17.8286 6.87274 18.9881 7.12201 20.0957C7.37128 21.2033 7.99007 22.1932 8.87662 22.9024C9.76317 23.6116 10.8647 23.9979 12 23.9979C13.1353 23.9979 14.2368 23.6116 15.1234 22.9024C16.0099 22.1932 16.6287 21.2033 16.878 20.0957C17.1273 18.9881 16.9922 17.8286 16.4949 16.808C15.9977 15.7874 15.1679 14.9664 14.142 14.48L13 13.938V8H11ZM9.00001 12.674V6H15V12.674C16.436 13.3551 17.5974 14.5047 18.2933 15.9335C18.9892 17.3624 19.1782 18.9856 18.8291 20.5361C18.48 22.0866 17.6136 23.4722 16.3725 24.4649C15.1314 25.4577 13.5893 25.9986 12 25.9986C10.4107 25.9986 8.86866 25.4577 7.62753 24.4649C6.3864 23.4722 5.52005 22.0866 5.17096 20.5361C4.82186 18.9856 5.0108 17.3624 5.7067 15.9335C6.4026 14.5047 7.56403 13.3551 9.00001 12.674ZM8.53501 17H15.465C15.8157 17.6081 16.0002 18.2978 16 18.9998C15.9998 19.7018 15.8148 20.3914 15.4637 20.9992C15.1125 21.6071 14.6076 22.1118 13.9996 22.4628C13.3916 22.8137 12.702 22.9984 12 22.9984C11.298 22.9984 10.6084 22.8137 10.0004 22.4628C9.39241 22.1118 8.88749 21.6071 8.53636 20.9992C8.18522 20.3914 8.00024 19.7018 8.00001 18.9998C7.99977 18.2978 8.18428 17.6081 8.53501 17ZM9.00001 6H15C15.2652 6 15.5196 6.10536 15.7071 6.29289C15.8947 6.48043 16 6.73478 16 7C16 7.26522 15.8947 7.51957 15.7071 7.70711C15.5196 7.89464 15.2652 8 15 8H9.00001C8.73479 8 8.48044 7.89464 8.2929 7.70711C8.10536 7.51957 8.00001 7.26522 8.00001 7C8.00001 6.73478 8.10536 6.48043 8.2929 6.29289C8.48044 6.10536 8.73479 6 9.00001 6Z" fill="black"/>
                                      <path d="M26.6693 7.99992C27.4028 7.99976 28.1156 7.75771 28.6975 7.31129C29.2795 6.86487 29.6979 6.23899 29.888 5.53064C30.0781 4.82229 30.0293 4.07101 29.7491 3.39322C29.4689 2.71542 28.973 2.14895 28.3383 1.78158C27.7035 1.41421 26.9653 1.26644 26.238 1.36119C25.5107 1.45593 24.835 1.78789 24.3155 2.30562C23.796 2.82336 23.4618 3.49797 23.3646 4.22492C23.2675 4.95188 23.4128 5.69059 23.778 6.32659L21.9687 7.53192C21.5988 7.12825 21.1136 6.84823 20.579 6.72988C20.0444 6.61153 19.4864 6.66061 18.9807 6.87043C18.475 7.08025 18.0461 7.44066 17.7523 7.90269C17.4585 8.36472 17.3141 8.90598 17.3386 9.45295C17.3631 9.99991 17.5554 10.5261 17.8894 10.96C18.2233 11.3939 18.6827 11.7144 19.2052 11.8782C19.7276 12.0419 20.2878 12.0408 20.8097 11.8751C21.3315 11.7094 21.7897 11.3871 22.122 10.9519L24.7133 12.2473C24.6112 12.7232 24.6862 13.2201 24.9242 13.6447C25.1622 14.0694 25.547 14.3926 26.0063 14.5539C26.4656 14.7152 26.968 14.7034 27.4192 14.5207C27.8705 14.3381 28.2396 13.9971 28.4574 13.5618C28.6753 13.1264 28.7268 12.6266 28.6025 12.1559C28.4781 11.6853 28.1864 11.2761 27.782 11.0052C27.3775 10.7343 26.8882 10.6201 26.4056 10.6842C25.923 10.7483 25.4804 10.9862 25.1607 11.3533L22.57 10.0579C22.7255 9.50589 22.6991 8.91844 22.4947 8.38259L24.4033 7.11126C25.019 7.68355 25.8288 8.00112 26.6693 7.99992ZM26.6693 6.99992C26.0505 6.99992 25.457 6.75409 25.0194 6.31651C24.5818 5.87892 24.336 5.28543 24.336 4.66659C24.336 4.04775 24.5818 3.45426 25.0194 3.01667C25.457 2.57909 26.0505 2.33326 26.6693 2.33326C27.2882 2.33326 27.8817 2.57909 28.3193 3.01667C28.7568 3.45426 29.0027 4.04775 29.0027 4.66659C29.0027 5.28543 28.7568 5.87892 28.3193 6.31651C27.8817 6.75409 27.2882 6.99992 26.6693 6.99992ZM20.0027 10.9999C19.5606 10.9999 19.1367 10.8243 18.8242 10.5118C18.5116 10.1992 18.336 9.77528 18.336 9.33326C18.336 8.89123 18.5116 8.46731 18.8242 8.15475C19.1367 7.84218 19.5606 7.66659 20.0027 7.66659C20.4447 7.66659 20.8686 7.84218 21.1812 8.15475C21.4937 8.46731 21.6693 8.89123 21.6693 9.33326C21.6693 9.77528 21.4937 10.1992 21.1812 10.5118C20.8686 10.8243 20.4447 10.9999 20.0027 10.9999ZM27.6693 12.6666C27.6693 12.9318 27.564 13.1862 27.3764 13.3737C27.1889 13.5612 26.9346 13.6666 26.6693 13.6666C26.4041 13.6666 26.1498 13.5612 25.9622 13.3737C25.7747 13.1862 25.6693 12.9318 25.6693 12.6666C25.6693 12.4014 25.7747 12.147 25.9622 11.9595C26.1498 11.7719 26.4041 11.6666 26.6693 11.6666C26.9346 11.6666 27.1889 11.7719 27.3764 11.9595C27.564 12.147 27.6693 12.4014 27.6693 12.6666Z" fill="black"/>
                                    </svg>

                                    <span class='name ml-1'>Produto: {{ roleProduct.product.name }} </span>
                                  </section>

                                  <section class='d-flex align-items-end justify-content-between mr-3'>
                                    <!--Cadastre o percentual de cada agente dentro do produto conforme indicado na FDS ou FISPQ-->
                                    <b-popover
                                      custom-class=''
                                      :target='`${roleProduct._id}_${roleProduct.product._id}_percentage`'
                                      placement='top'
                                      triggers='hover'
                                    >
                                      <span class='label'>
                                        Clique para editar/cadastrar a porcentagem do produto em cada agente
                                      </span>

                                    </b-popover>
                                    <button
                                      :id='`${roleProduct._id}_${roleProduct.product._id}_percentage`'
                                      :class="!!(roleProduct.product.legalSearches.find((x) => !x.percentage || x.percentage <= 0)) ? 'btn-termsofuses-not-filled' : 'btn-termsofuses'"
                                      @click='showModalAgentPercentage(roleProduct.product)'
                                    >
                                      <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24'
                                           fill='none'>
                                        <path
                                          d='M18.5 3.5L3.5 18.501L5.496 20.497L20.496 5.497L18.5 3.5ZM7.001 5C6.73836 4.99974 6.47823 5.05121 6.23548 5.15148C5.99273 5.25174 5.7721 5.39884 5.5862 5.58437C5.4003 5.7699 5.25276 5.99023 5.15201 6.23279C5.05125 6.47534 4.99926 6.73536 4.999 6.998C4.99874 7.26064 5.05021 7.52077 5.15048 7.76352C5.25074 8.00627 5.39784 8.2269 5.58337 8.4128C5.7689 8.5987 5.98923 8.74624 6.23179 8.84699C6.47434 8.94775 6.73436 8.99974 6.997 9C7.52743 9.00053 8.03635 8.79033 8.4118 8.41563C8.78725 8.04093 8.99847 7.53243 8.999 7.002C8.99953 6.47157 8.78933 5.96265 8.41463 5.5872C8.03993 5.21175 7.53143 5.00053 7.001 5ZM17.001 15C16.4706 14.9995 15.9616 15.2097 15.5862 15.5844C15.2108 15.9591 14.9995 16.4676 14.999 16.998C14.9985 17.5284 15.2087 18.0374 15.5834 18.4128C15.9581 18.7882 16.4666 18.9995 16.997 19C17.2596 19.0003 17.5198 18.9488 17.7625 18.8485C18.0053 18.7483 18.2259 18.6012 18.4118 18.4156C18.5977 18.2301 18.7452 18.0098 18.846 17.7672C18.9467 17.5247 18.9987 17.2646 18.999 17.002C18.9993 16.7394 18.9478 16.4792 18.8475 16.2365C18.7473 15.9937 18.6002 15.7731 18.4146 15.5872C18.2291 15.4013 18.0088 15.2538 17.7662 15.153C17.5237 15.0523 17.2636 15.0003 17.001 15Z'
                                          fill='#022245' />
                                      </svg>
                                    </button>


                                    <!--Cadastrar/Atualizar produto-->
                                    <b-popover
                                      custom-class=''
                                      :target='`${roleProduct._id}_${roleProduct.product._id}_editProduct`'
                                      placement='top'
                                      triggers='hover'
                                    >
                                      <span class='label'>
                                        Clique para editar o produto
                                      </span>

                                    </b-popover>
                                    <button
                                      :id='`${roleProduct._id}_${roleProduct.product._id}_editProduct`'
                                      class="btn-termsofuses"
                                      @click='showModalEditProduct(roleProduct.product.productLegalConsultationId)'
                                    >
                                      <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' fill='currentColor'
                                           class='bi bi-pencil-square' viewBox='0 0 16 16'>
                                        <path
                                          d='M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z' />
                                        <path fill-rule='evenodd'
                                              d='M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z' />
                                      </svg>
                                    </button>


                                    <section class='termsofuses-actions d-flex align-items-center'>
                                    <!--Exposição Permanente-->
                                    <b-popover
                                      custom-class=''
                                      :target='`${roleProduct._id}_${roleProduct.product._id}_permanentExhibition`'
                                      placement='top'
                                      triggers='hover'
                                    >
                                        <span
                                          class='label'
                                          v-if='roleProduct.product.permanentExhibition && roleProduct.product.permanentExhibition._id'
                                        >
                                          Clique para editar a exposição permanente
                                        </span>

                                      <span v-else class='label'>
                                          Clique para cadastrar a exposição permanente
                                        </span>
                                    </b-popover>
                                    <button
                                      :id='`${roleProduct._id}_${roleProduct.product._id}_permanentExhibition`'
                                      :class="roleProduct.product.permanentExhibition &&
                                        roleProduct.product.permanentExhibition._id &&
                                        analysisPermanentExposureAndEffectiveProtection.interactedPermanentExposureQuestions(roleProduct.product.permanentExhibition)
                                          ? 'btn-completed-permanent-exhibition'
                                          : 'btn-permanent-exhibition-without-filling'"
                                      @click="showPermanentExhibition(roleProduct.product, sector, $event)"
                                    >
                                      <p class='image-permanent-exhibition'></p>
                                    </button>


                                    <!--Quantidade diária utilizada deste produto (em kg ou L)-->
                                    <!--Frequência de utilização deste produto-->
                                    <!--Tempo de exposição do trabalhador com o uso do produto (por dia)-->
                                    <b-popover
                                      custom-class=''
                                      :target='`${roleProduct._id}_${roleProduct.product._id}_frequencyUse`'
                                      placement='top'
                                      triggers='hover'
                                    >
                                      <span class='label'
                                        v-if='roleProduct.product.termsofuses && roleProduct.product.termsofuses.quantityUsed && roleProduct.product.termsofuses.frequencyUse && roleProduct.product.termsofuses.exposureTime'
                                      >
                                        Clique para editar a quantidade diária utilizada deste produto,
                                        frequência de utilização deste produto e tempo de exposição do
                                        trabalhador com o uso do produto
                                      </span>
                                      <span v-else class='label'>
                                        Clique para cadastrar a quantidade diária utilizada deste produto, frequência de
                                        utilização deste produto e tempo de exposição do trabalhador com o uso do produto
                                      </span>
                                    </b-popover>
                                    <button
                                      :id='`${roleProduct._id}_${roleProduct.product._id}_frequencyUse`'
                                      :class="roleProduct.product.termsofuses &&
                                        roleProduct.product.termsofuses.quantityUsed &&
                                        roleProduct.product.termsofuses.frequencyUse &&
                                        roleProduct.product.termsofuses.exposureTime
                                          ? 'btn-termsofuses'
                                          : 'btn-termsofuses-not-filled'"
                                      @click="showWorkersModal(roleProduct.product, 'quantityUsedFrequencyExposureTimeUseModal')"
                                    >
                                      <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24'
                                           fill='none'>
                                        <path
                                          d='M22.1492 9.65625H16.1492C16.0461 9.65625 15.9617 9.74062 15.9617 9.84375V10.9688C15.9617 11.0719 16.0461 11.1562 16.1492 11.1562H22.1492C22.2523 11.1562 22.3367 11.0719 22.3367 10.9688V9.84375C22.3367 9.74062 22.2523 9.65625 22.1492 9.65625ZM19.0086 12.8438H16.1492C16.0461 12.8438 15.9617 12.9281 15.9617 13.0312V14.1562C15.9617 14.2594 16.0461 14.3438 16.1492 14.3438H19.0086C19.1117 14.3438 19.1961 14.2594 19.1961 14.1562V13.0312C19.1961 12.9281 19.1117 12.8438 19.0086 12.8438ZM11.1875 7.55859H10.1727C10.0273 7.55859 9.91016 7.67578 9.91016 7.82109V13.6336C9.91016 13.718 9.95 13.7953 10.018 13.8445L13.5078 16.3898C13.625 16.4742 13.7891 16.4508 13.8734 16.3336L14.4758 15.5109V15.5086C14.5602 15.3914 14.5344 15.2273 14.4172 15.143L11.4477 12.9961V7.82109C11.45 7.67578 11.3305 7.55859 11.1875 7.55859Z'
                                          fill='#022245' />
                                        <path
                                          d='M18.8625 15.7945H17.5078C17.3766 15.7945 17.2524 15.8625 17.182 15.975C16.8844 16.4461 16.5375 16.882 16.1391 17.2804C15.4524 17.9671 14.6531 18.5062 13.7649 18.8812C12.8438 19.2703 11.8664 19.4671 10.8586 19.4671C9.84845 19.4671 8.87111 19.2703 7.95236 18.8812C7.06408 18.5062 6.26486 17.9671 5.57814 17.2804C4.89142 16.5937 4.35236 15.7945 3.97736 14.9062C3.5883 13.9875 3.39142 13.0101 3.39142 12C3.39142 10.9898 3.5883 10.0148 3.97736 9.09371C4.35236 8.20543 4.89142 7.40621 5.57814 6.71949C6.26486 6.03277 7.06408 5.49371 7.95236 5.11871C8.87111 4.72965 9.8508 4.53277 10.8586 4.53277C11.8688 4.53277 12.8461 4.72965 13.7649 5.11871C14.6531 5.49371 15.4524 6.03277 16.1391 6.71949C16.5375 7.11793 16.8844 7.55386 17.182 8.02496C17.2524 8.13746 17.3766 8.20543 17.5078 8.20543H18.8625C19.0242 8.20543 19.1274 8.03668 19.0547 7.89371C17.5266 4.85386 14.4281 2.87808 10.9688 2.83824C5.90392 2.77496 1.69689 6.92105 1.68752 11.9812C1.67814 17.0507 5.78673 21.164 10.8563 21.164C14.3602 21.164 17.5102 19.1812 19.0547 16.1062C19.1274 15.9632 19.0219 15.7945 18.8625 15.7945Z'
                                          fill='#022245' />
                                      </svg>
                                    </button>





                                    <!--Condição de ventilação instalada e específica para o processo produtivo-->
                                    <b-popover
                                      custom-class=''
                                      :target='`${roleProduct._id}_${roleProduct.product._id}_ventilationInstalledSpecificallyForTheProductionProcessd`'
                                      placement='top'
                                      triggers='hover'
                                    >
                                      <span class='label'
                                            v-if='roleProduct.product.termsofuses && roleProduct.product.termsofuses.ventilationInstalledSpecificallyForTheProductionProcess'>
                                        Clique para editar a condição de ventilação instalada e específica para o processo produtivo
                                      </span>
                                      <span v-else class='label'>
                                        Clique para cadastrar a condição de ventilação instalada e específica para o processo produtivo
                                      </span>
                                    </b-popover>
                                    <button
                                      :id='`${roleProduct._id}_${roleProduct.product._id}_ventilationInstalledSpecificallyForTheProductionProcessd`'
                                      :class="roleProduct.product.termsofuses && roleProduct.product.termsofuses.ventilationInstalledSpecificallyForTheProductionProcess ? 'btn-termsofuses' : 'btn-termsofuses-not-filled'"
                                      @click="showWorkersModal(roleProduct.product, 'ventilationInstalledSpecificallyForTheProductionProcessModal')"
                                    >
                                      <svg width="30" height="30" viewBox="0 0 2025 2078" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.5372 0.533264C12.2705 0.933228 12.4038 157.6 12.8038 348.933C13.3372 591.2 14.0038 699.067 15.0705 704.667C15.8705 709.067 16.9372 714.8 17.3372 717.333C17.8705 719.867 18.6705 723.2 19.2038 724.667C19.8705 726.133 21.7372 731.867 23.4705 737.333C26.5372 747.2 40.2705 776.267 42.2705 777.067C42.8038 777.333 43.3372 778.133 43.3372 778.8C43.3372 780.133 49.8705 789.733 58.8038 801.467C64.8038 809.2 86.1372 830.133 94.6705 836.667C103.871 843.6 112.537 849.333 113.871 849.333C114.537 849.333 115.337 849.867 115.604 850.4C115.871 850.933 123.204 854.933 132.004 859.2C140.804 863.467 149.071 867.6 150.271 868.133C151.604 868.8 153.871 869.333 155.204 869.333C156.671 869.333 158.137 869.867 158.537 870.533C158.937 871.2 161.204 872 163.604 872.4C166.004 872.8 171.071 873.867 174.671 874.667C189.871 878.133 207.871 878.533 346.671 878.533C493.204 878.533 509.071 878 527.737 873.333C543.871 869.2 543.871 869.067 553.071 865.467C567.337 859.6 586.271 849.333 599.871 840C616.671 828.4 638.537 806.4 649.337 790.133C654.404 782.667 658.004 776.667 658.937 774.667C659.471 773.6 660.137 772.4 660.671 772C661.604 771.333 670.671 752.533 673.071 746.667C673.737 744.8 674.804 742.267 675.471 741.067C676.137 739.733 676.671 737.733 676.671 736.667C676.671 735.6 677.204 733.6 677.871 732.267C679.737 728.667 682.004 720.667 682.004 718C682.004 716.667 682.537 713.733 683.204 711.467C684.004 709.2 685.471 700.4 686.671 692C688.537 678.133 688.804 643.067 688.404 338.667L688.004 0.666565H625.604H563.337V340.933C563.337 627.733 563.071 682 561.471 686.267C560.537 689.067 558.804 694 557.871 697.333C553.604 712 540.671 728.933 526.271 739.067C518.671 744.267 508.937 749.333 506.404 749.333C505.471 749.333 503.604 749.867 502.271 750.533C492.937 755.2 493.071 755.2 361.337 755.6C213.204 756.267 204.004 755.733 188.404 747.867C187.071 747.2 185.337 746.667 184.537 746.667C183.737 746.667 178.404 743.333 172.804 739.333C163.604 732.933 158.004 727.6 151.337 719.2C149.337 716.533 142.537 702.933 139.204 694.667C137.604 690.667 137.337 637.467 136.937 345.333L136.671 0.666565L74.8038 0.399902C40.8038 0.266602 12.8038 0.266602 12.5372 0.533264Z" fill="#FF0000"/>
                                        <path d="M889.333 0.799805C888.4 1.19995 888.133 345.2 888.267 1030.27L888.667 2059.33L938.667 2059.73L988.667 2060L988.933 1032C988.933 466.667 989.067 3.19995 989.2 2.2666C989.333 1.06665 978.533 0.666504 940 0.533203C912.933 0.399902 890.133 0.533203 889.333 0.799805Z" fill="#FF0000"/>
                                        <path d="M1566.67 414.8C1564.54 415.466 1560.54 416.4 1558 416.8C1555.47 417.066 1551.6 418 1549.34 418.666C1547.2 419.333 1542.67 420.533 1539.34 421.333C1536 422.266 1532.27 423.466 1531.07 424.133C1529.74 424.8 1527.74 425.333 1526.67 425.333C1525.6 425.333 1523.6 425.866 1522.27 426.533C1521.07 427.2 1518.54 428.266 1516.67 428.933C1514.8 429.733 1510.94 431.6 1508 433.066C1505.07 434.533 1498.94 437.733 1494.54 439.866C1481.2 446.533 1466.27 457.866 1450.27 473.733C1425.74 498 1415.74 512.4 1400.14 546.933C1398.27 551.066 1396.67 555.466 1396.67 556.533C1396.67 557.6 1396.14 558.933 1395.34 559.333C1394.67 559.733 1394 561.866 1394 564C1394 566.133 1393.47 568.133 1392.8 568.533C1392.14 568.933 1391.34 571.6 1390.94 574.266C1390.4 577.066 1389.34 583.2 1388.54 588C1386.27 599.6 1386.27 644.4 1388.4 658C1389.34 663.867 1390.4 670.933 1390.8 673.733C1391.34 676.4 1392.14 679.066 1392.8 679.466C1393.47 679.867 1394 681.867 1394 684C1394 686.133 1394.67 688.266 1395.34 688.666C1396.14 689.066 1396.67 690.666 1396.67 692.133C1396.67 693.466 1397.2 695.733 1397.87 697.066C1398.67 698.266 1400.8 702.933 1402.67 707.333C1409.6 722.666 1412 727.333 1416.27 733.6C1418.67 737.066 1420.67 740.533 1420.67 741.066C1420.67 741.733 1421.87 743.333 1423.34 744.666C1424.8 746 1426 747.733 1426 748.533C1426 749.333 1427.6 751.867 1429.74 754C1431.74 756.267 1435.6 760.8 1438.4 764.267C1444.8 772.267 1453.87 781.2 1461.74 787.6C1465.2 790.4 1468.27 793.067 1468.67 793.467C1470.14 795.2 1495.47 811.867 1499.2 813.467C1501.47 814.533 1503.34 815.733 1503.34 816.267C1503.34 816.933 1504.14 817.333 1505.2 817.333C1506.27 817.333 1509.74 818.667 1512.94 820.133C1516 821.733 1520.8 824 1523.34 825.067C1525.87 826.133 1529.07 827.6 1530.27 828.133C1531.6 828.8 1533.87 829.333 1535.2 829.333C1536.67 829.333 1538.27 829.867 1538.67 830.667C1539.07 831.333 1541.2 832 1543.34 832C1545.47 832 1547.47 832.533 1547.87 833.2C1548.27 833.867 1550.94 834.667 1553.6 835.067C1556.4 835.467 1563.47 836.533 1569.34 837.467C1583.07 839.733 1618.27 839.733 1632 837.467C1637.87 836.533 1644.94 835.467 1647.74 835.067C1650.4 834.667 1653.07 833.867 1653.47 833.2C1653.87 832.533 1655.87 832 1658 832C1660.14 832 1662.27 831.333 1662.67 830.667C1663.07 829.867 1664.67 829.333 1666.14 829.333C1667.47 829.333 1669.74 828.8 1671.07 828.133C1672.27 827.6 1676.67 825.467 1680.67 823.6C1702.67 813.6 1707.07 811.067 1719.34 802.8C1736.4 791.2 1753.34 776.133 1762 764.666C1764.8 760.933 1769.6 754.8 1772.54 750.933C1775.6 747.066 1778 743.466 1778 742.933C1778 742.267 1779.07 740.666 1780.4 739.2C1783.87 735.333 1793.07 718 1796.94 708C1797.74 706.133 1798.8 703.6 1799.47 702.4C1800.14 701.066 1800.67 698.8 1800.67 697.466C1800.67 696 1801.34 694.4 1802 694C1802.8 693.6 1803.34 691.466 1803.34 689.333C1803.34 687.2 1804 685.066 1804.67 684.666C1805.47 684.266 1806 682.533 1806 680.933C1806 679.333 1806.8 675.733 1807.87 672.666C1811.6 662 1812.67 650.666 1812.67 624.4C1812.67 599.066 1811.87 590.666 1808.27 578C1807.47 575.066 1806.67 571.6 1806.54 570.266C1806.4 568.933 1805.74 566.533 1805.07 564.933C1804.27 563.333 1802.94 559.6 1802.14 556.667C1801.2 553.733 1799.87 550 1799.2 548.266C1798.54 546.667 1797.47 544 1796.8 542.266C1794.94 537.2 1785.74 519.6 1783.2 515.733C1781.74 513.866 1780.67 511.733 1780.67 511.066C1780.67 510.533 1778.8 507.866 1776.67 505.333C1774.54 502.8 1772.67 500 1772.67 499.066C1772.67 498.266 1772.27 497.333 1771.6 497.066C1771.07 496.8 1767.74 493.066 1764 488.666C1749.07 470.533 1736 459.6 1708 441.6C1702.8 438.4 1681.34 428 1679.6 428C1678.67 428 1676.94 427.466 1675.6 426.8C1671.07 424.533 1666.67 422.8 1662.67 422C1660.54 421.6 1656.54 420.666 1654 420C1647.07 418.266 1638 416.133 1631.6 414.666C1624.4 412.933 1572 413.2 1566.67 414.8Z" fill="#FF0000"/>
                                        <path d="M1550.94 890.267C1550.4 890.667 1550 912.933 1550 939.467V987.867L1544.4 993.733C1541.2 996.8 1536.27 1002.13 1533.47 1005.33C1530.54 1008.67 1520.4 1019.73 1510.67 1030C1489.6 1052.4 1467.34 1076.27 1449.47 1095.73C1442.27 1103.6 1430 1116.67 1422.14 1124.8C1414.4 1132.93 1399.34 1149.07 1388.67 1160.67C1378 1172.27 1364.27 1187.33 1358 1193.87C1351.74 1200.53 1344 1208.93 1340.67 1212.67C1337.47 1216.27 1329.74 1224.8 1323.47 1231.33C1317.2 1238 1307.87 1248.13 1302.67 1254C1297.6 1259.73 1289.2 1268.8 1284 1274C1278.94 1279.2 1269.34 1289.47 1262.8 1296.8C1256.14 1304 1243.6 1317.6 1234.8 1326.8C1216.27 1346 1202.8 1361.07 1195.87 1370.13L1191.07 1376.4L1207.47 1392.53C1232.14 1416.53 1257.6 1440 1259.07 1440C1259.87 1440 1261.74 1438.4 1263.34 1436.27C1264.94 1434.27 1275.07 1423.33 1285.87 1412C1296.67 1400.67 1309.07 1387.47 1313.47 1382.67C1317.74 1377.87 1327.47 1367.73 1334.8 1360C1342.27 1352.27 1350.67 1343.33 1353.34 1340C1356 1336.67 1363.74 1328.27 1370.54 1321.33C1377.2 1314.27 1385.07 1305.87 1387.87 1302.67C1390.8 1299.33 1397.34 1292.13 1402.54 1286.67C1407.74 1281.2 1414.67 1273.6 1417.74 1270C1420.94 1266.27 1427.87 1258.8 1433.2 1253.33C1438.4 1247.87 1446.67 1238.8 1451.6 1233.33C1456.4 1227.87 1463.87 1219.73 1468.14 1215.2C1472.54 1210.8 1480.14 1202.4 1485.34 1196.53C1490.4 1190.8 1498.54 1181.73 1503.47 1176.67C1518 1161.2 1537.07 1140.13 1542 1134C1544.54 1130.67 1547.34 1128.27 1548.27 1128.4C1549.47 1128.53 1549.87 1179.07 1550.14 1345.6C1550.4 1545.47 1550.27 1562.67 1548.27 1565.73C1547.07 1567.6 1544.8 1571.33 1543.34 1573.87C1541.87 1576.53 1539.47 1580.67 1538.14 1583.2C1536.67 1585.6 1534.8 1589.07 1533.74 1590.8C1532.8 1592.53 1531.34 1594.93 1530.4 1596C1529.6 1597.07 1526.94 1601.6 1524.54 1606C1522.14 1610.4 1519.2 1615.6 1518.14 1617.6C1516.94 1619.47 1513.87 1624.53 1511.34 1628.93C1508.8 1633.2 1505.74 1638.4 1504.4 1640.67C1503.07 1642.8 1500.8 1647.07 1499.34 1650C1497.74 1652.93 1494.67 1658.27 1492.4 1662C1490.14 1665.6 1486.4 1672 1484.27 1676C1482 1680 1479.2 1684.93 1478.14 1686.93C1476.94 1688.8 1473.87 1693.87 1471.34 1698.27C1463.47 1711.6 1459.2 1719.2 1458.4 1721.6C1458 1722.93 1457.2 1724 1456.67 1724C1456 1724 1454.14 1726.8 1452.27 1730.4C1446 1742.53 1442.54 1748.67 1439.2 1754C1435.47 1759.73 1429.87 1769.47 1425.47 1778C1423.87 1780.93 1422.27 1783.6 1421.87 1784C1421.47 1784.4 1419.07 1788.27 1416.54 1792.67C1414.14 1797.07 1410.94 1802.4 1409.6 1804.67C1408.4 1806.8 1406.94 1809.73 1406.54 1811.07C1406 1812.27 1405.2 1813.33 1404.54 1813.33C1403.87 1813.33 1403.34 1814.53 1403.34 1815.87C1403.34 1817.33 1402.8 1818.67 1402.27 1818.93C1401.2 1819.33 1391.34 1835.47 1391.34 1836.8C1391.34 1837.2 1389.6 1840 1387.6 1843.07C1385.47 1846.13 1383.34 1849.6 1382.94 1850.67C1382.4 1851.73 1380.54 1855.07 1378.67 1858C1376.8 1860.93 1374.4 1865.47 1373.07 1868C1371.87 1870.53 1370.54 1872.93 1370.14 1873.33C1369.34 1874 1367.2 1877.47 1363.74 1884C1362.67 1885.87 1360.4 1889.73 1358.54 1892.67C1356.8 1895.6 1354.94 1898.93 1354.4 1900C1353.87 1901.07 1353.2 1902.27 1352.67 1902.67C1352.27 1903.07 1350.8 1905.47 1349.6 1908C1348.27 1910.53 1345.87 1915.07 1344 1918C1342.27 1920.93 1340 1924.8 1338.94 1926.67C1338 1928.53 1335.87 1932.27 1334.27 1934.93C1332.67 1937.73 1330.14 1942 1328.8 1944.53C1327.34 1947.07 1324.67 1951.6 1322.8 1954.53C1320.8 1957.47 1319.34 1960.53 1319.34 1961.33C1319.34 1962 1318.8 1962.67 1318.14 1962.67C1317.47 1962.67 1316.67 1963.73 1316.14 1964.93C1315.74 1966.27 1314.27 1969.07 1313.07 1971.33C1311.74 1973.47 1308.54 1978.93 1306.14 1983.33C1303.6 1987.73 1301.2 1991.6 1300.8 1992C1300.4 1992.4 1298.8 1995.07 1297.2 1998C1292 2007.87 1286.94 2016.67 1283.34 2022.27C1279.47 2028 1280 2030.67 1284.8 2030.67C1286.14 2030.67 1287.34 2031.2 1287.6 2031.73C1288 2032.93 1303.07 2041.6 1321.34 2051.2C1324.27 2052.8 1328.54 2055.2 1330.67 2056.8C1332.94 2058.27 1337.34 2060.93 1340.67 2062.8C1344 2064.53 1347.74 2066.8 1349.07 2067.87C1352 2070.27 1356.67 2073.07 1359.74 2074.13C1360.94 2074.53 1362 2075.47 1362 2076.13C1362 2076.8 1362.67 2077.33 1363.34 2077.33C1364.14 2077.33 1364.67 2076.4 1364.67 2075.33C1364.67 2074.27 1366.27 2071.2 1368.14 2068.4C1370 2065.6 1372.14 2062.13 1372.8 2060.67C1373.47 2059.2 1375.6 2055.6 1377.47 2052.67C1379.2 2049.73 1381.07 2046.27 1381.6 2044.93C1382 2043.73 1382.8 2042.67 1383.47 2042.67C1384.14 2042.67 1384.67 2042.13 1384.67 2041.33C1384.67 2040.67 1387.34 2035.47 1390.67 2029.87C1394 2024.4 1396.67 2019.47 1396.67 2019.07C1396.67 2018.8 1398.54 2015.87 1400.67 2012.67C1402.94 2009.47 1404.67 2006.4 1404.67 2005.87C1404.67 2005.33 1405.47 2003.87 1406.54 2002.8C1407.47 2001.6 1409.74 1998 1411.47 1994.67C1413.2 1991.33 1414.94 1988.4 1415.34 1988C1416.14 1987.2 1418.94 1982.27 1422.67 1975.33C1425.74 1969.47 1430.54 1961.47 1432.27 1959.33C1432.8 1958.53 1434.54 1955.6 1436.14 1952.67C1440.54 1944.13 1446.14 1934.4 1449.87 1928.67C1451.74 1925.73 1454.54 1920.93 1456.14 1918C1460.54 1909.47 1464.8 1902.13 1466.54 1900C1467.34 1898.93 1469.47 1895.47 1471.07 1892.53C1472.67 1889.47 1474.8 1885.6 1475.74 1883.87C1477.6 1880.27 1485.2 1867.6 1489.6 1860.27C1491.34 1857.47 1493.6 1853.2 1494.94 1850.67C1496.14 1848.13 1497.47 1845.73 1497.87 1845.33C1498.4 1844.93 1500.14 1842 1501.87 1838.67C1503.6 1835.33 1505.74 1831.87 1506.4 1830.93C1508.4 1828.4 1515.34 1815.73 1516.27 1812.93C1516.67 1811.73 1517.47 1810.67 1518.14 1810.67C1518.8 1810.67 1519.34 1810 1519.34 1809.2C1519.34 1808.4 1520.4 1806.13 1521.87 1804.27C1523.2 1802.27 1526.4 1796.8 1528.94 1792C1534.94 1780.67 1537.2 1776.8 1538.14 1776C1538.54 1775.6 1539.34 1774.4 1539.74 1773.33C1540.27 1772.27 1542.14 1768.93 1544 1766C1545.87 1763.07 1548.27 1758.53 1549.6 1756C1550.8 1753.47 1552.14 1751.07 1552.54 1750.67C1553.34 1750 1555.47 1746.53 1558.94 1740C1560 1738.13 1562.27 1734.27 1564.14 1731.33C1566 1728.4 1567.74 1724.93 1568.27 1723.6C1568.67 1722.4 1569.47 1721.33 1570.14 1721.33C1570.8 1721.33 1571.34 1720.13 1571.34 1718.8C1571.34 1717.33 1571.87 1716 1572.4 1715.73C1573.34 1715.33 1576.27 1710.67 1583.07 1698.53C1588.67 1688.53 1589.34 1687.33 1590 1686.67C1590.4 1686.27 1592.27 1683.07 1594.27 1679.33C1596.27 1675.73 1598.27 1672.53 1598.94 1672.4C1600.54 1671.87 1609.2 1685.47 1618.54 1703.33C1620.14 1706.27 1621.74 1709.2 1622.4 1710C1624.54 1712.93 1629.47 1720.93 1631.34 1724.67C1632.4 1726.8 1634.94 1731.2 1636.94 1734.27C1638.94 1737.33 1640.67 1740.27 1640.67 1740.8C1640.67 1741.33 1641.47 1742.8 1642.54 1743.87C1643.47 1745.07 1645.74 1748.67 1647.47 1752C1649.2 1755.33 1651.07 1758.27 1651.47 1758.67C1651.87 1759.07 1652.54 1760.27 1653.07 1761.33C1653.6 1762.4 1655.47 1765.73 1657.34 1768.67C1659.2 1771.6 1661.07 1774.93 1661.6 1776C1662 1777.07 1664 1780.4 1665.87 1783.33C1667.74 1786.27 1670.54 1791.07 1672.14 1794C1673.6 1796.93 1676 1801.2 1677.47 1803.6C1679.74 1807.33 1685.47 1817.07 1691.6 1827.33C1692.94 1829.47 1694.94 1833.47 1696.27 1836C1697.47 1838.53 1698.8 1840.93 1699.34 1841.33C1700.54 1842.4 1706.54 1852.4 1708.67 1856.67C1709.74 1858.8 1712.14 1863.07 1714.14 1866C1716 1868.93 1718 1872.27 1718.4 1873.33C1718.94 1874.4 1720.94 1877.73 1722.67 1880.67C1724.54 1883.6 1726.4 1887.07 1726.94 1888.27C1727.34 1889.6 1728.14 1890.67 1728.67 1890.67C1729.2 1890.67 1730 1891.73 1730.4 1893.07C1730.94 1894.27 1732.8 1897.73 1734.67 1900.67C1736.4 1903.6 1738.4 1906.93 1738.94 1908C1739.34 1909.07 1741.34 1912.4 1743.34 1915.33C1745.2 1918.27 1747.87 1922.8 1749.07 1925.33C1750.4 1927.87 1752.67 1932.13 1754.4 1934.93C1757.87 1940.67 1766 1954.27 1768.14 1958C1768.94 1959.47 1770.94 1963.07 1772.54 1966C1774.27 1968.93 1776.27 1972.13 1776.94 1973.07C1778.67 1975.07 1782.54 1981.73 1785.6 1988C1786.8 1990.53 1788.27 1992.93 1788.8 1993.33C1789.2 1993.73 1791.34 1996.93 1793.2 2000.67C1795.2 2004.27 1798.27 2009.73 1800.14 2012.67C1802 2015.6 1803.74 2019.07 1804.27 2020.27C1804.67 2021.6 1805.47 2022.67 1806 2022.67C1806.54 2022.67 1807.34 2023.73 1807.74 2024.93C1808.27 2026.27 1810 2029.73 1811.87 2032.67C1813.74 2035.6 1816 2039.47 1817.07 2041.33C1818 2043.2 1820.14 2046.93 1821.74 2049.6C1823.34 2052.4 1826 2056.93 1827.6 2059.6C1829.2 2062.4 1831.2 2066.27 1832.27 2068.13C1835.07 2073.6 1837.6 2075.33 1840 2073.33C1842.4 2071.33 1848.67 2067.73 1855.34 2064.4C1857.87 2063.2 1860.27 2061.87 1860.67 2061.47C1861.34 2060.67 1864.8 2058.53 1871.34 2055.07C1873.2 2054 1877.07 2051.73 1880 2050C1882.94 2048.13 1887.47 2045.73 1890 2044.4C1892.54 2043.2 1894.94 2041.73 1895.34 2041.33C1895.74 2040.8 1896.94 2040.13 1898 2039.6C1899.07 2039.07 1902.4 2037.2 1905.34 2035.33C1908.27 2033.47 1911.6 2031.6 1912.67 2031.07C1913.74 2030.67 1916.27 2029.07 1918.27 2027.73C1922.4 2024.93 1922.4 2025.47 1915.47 2014C1914.14 2011.73 1911.87 2007.87 1910.4 2005.33C1908.94 2002.8 1904.94 1996 1901.47 1990.27C1898.14 1984.53 1895.34 1979.2 1895.34 1978.53C1895.34 1977.87 1894.8 1977.33 1894.14 1977.33C1893.47 1977.33 1892.67 1976.27 1892.27 1974.93C1891.74 1973.73 1890 1970.27 1888.14 1967.33C1881.87 1957.33 1878 1950.27 1878 1949.2C1878 1948.53 1877.6 1948 1877.07 1948C1876.4 1948 1875.34 1946.67 1874.54 1944.93C1870.67 1937.33 1866.27 1929.47 1862.67 1924C1857.6 1916.27 1854.67 1911.2 1851.74 1905.33C1850.54 1902.8 1849.07 1900.4 1848.54 1900C1848.14 1899.6 1846.14 1896.27 1844.14 1892.67C1840.54 1885.73 1839.74 1884.4 1833.87 1875.33C1832 1872.4 1830 1869.07 1829.6 1868C1829.07 1866.93 1827.07 1863.6 1825.34 1860.67C1823.47 1857.73 1821.6 1854.27 1821.07 1852.93C1820.67 1851.73 1819.87 1850.67 1819.2 1850.67C1818.54 1850.67 1818 1849.47 1818 1848C1818 1846.53 1817.47 1845.33 1816.94 1845.33C1816.4 1845.33 1814.27 1842.13 1812.14 1838.27C1810.14 1834.53 1806.4 1828 1803.87 1824C1801.34 1820 1798.67 1815.47 1798 1814C1797.34 1812.53 1795.34 1809.2 1793.74 1806.4C1790.4 1801.2 1782.4 1787.73 1779.87 1783.33C1774.27 1773.33 1771.87 1769.33 1767.87 1763.07C1765.34 1759.2 1763.34 1755.33 1763.34 1754.67C1763.34 1753.87 1762.8 1753.33 1762.14 1753.33C1761.47 1753.33 1760.67 1752.27 1760.27 1750.93C1759.87 1749.73 1757.34 1745.07 1754.8 1740.67C1752.14 1736.27 1749.07 1730.67 1747.74 1728.27C1746.54 1726 1745.07 1724 1744.4 1724C1743.87 1724 1743.34 1722.8 1743.34 1721.33C1743.34 1719.87 1742.8 1718.67 1742.14 1718.67C1741.47 1718.67 1740.67 1717.6 1740.27 1716.27C1739.74 1715.07 1737.87 1711.6 1736 1708.67C1734.27 1705.73 1732.27 1702.4 1731.74 1701.33C1731.34 1700.27 1729.34 1696.93 1727.47 1694C1722.54 1686.27 1716.67 1675.73 1715.74 1672.93C1715.34 1671.73 1714.54 1670.67 1713.87 1670.67C1713.2 1670.67 1711.47 1668.13 1710 1664.93C1708.54 1661.87 1706.27 1657.47 1704.94 1655.33C1703.6 1653.07 1700.54 1647.87 1698 1643.6C1695.47 1639.2 1692 1633.6 1690.27 1630.93C1688.67 1628.13 1686.94 1625.07 1686.4 1624C1685.87 1622.93 1685.2 1621.73 1684.8 1621.33C1684 1620.67 1683.07 1619.07 1676.94 1608.13C1675.07 1604.8 1671.34 1598.13 1668.4 1593.47C1665.6 1588.93 1663.34 1584.8 1663.34 1584.53C1663.34 1584.27 1660.54 1579.47 1657.07 1573.73L1650.67 1563.33L1650.27 1344.93C1650 1162.27 1650.27 1126.67 1651.74 1126.67C1652.8 1126.67 1669.74 1143.33 1689.47 1163.6C1709.2 1184 1760.4 1236 1803.34 1279.2C1846.27 1322.27 1882 1358.27 1882.8 1359.2C1901.34 1378 1950.14 1423.87 1954.67 1426.53C1957.6 1428.4 1958.27 1428.13 1964.94 1422.67C1974.94 1414.53 2024.67 1365.07 2024.67 1363.2C2024.67 1361.6 1988.8 1325.87 1971.87 1310.53C1966.67 1305.87 1892.14 1231.73 1806.14 1146L1649.87 989.867L1650.27 940.4C1650.67 891.733 1650.67 890.8 1648 890.133C1644.14 889.067 1552 889.2 1550.94 890.267Z" fill="#FF0000"/>
                                        <path d="M488.664 924.667C487.731 925.733 486.531 926.667 485.864 926.667C485.198 926.667 481.064 929.467 476.531 932.933C463.998 942.667 453.064 959.867 450.664 973.333C447.598 991.6 448.931 1003.33 455.464 1016.27C456.131 1017.6 456.664 1019.33 456.664 1020.13C456.664 1023.6 471.864 1043.2 486.798 1058.8C520.131 1093.87 526.398 1106.8 525.864 1140.8C525.731 1150 525.998 1157.73 526.264 1158.13C526.664 1158.4 527.998 1157.47 529.331 1156C530.664 1154.53 532.398 1153.33 533.331 1153.33C535.598 1153.33 557.331 1131.6 559.598 1127.07C560.664 1125.07 562.798 1121.2 564.264 1118.67C567.731 1112.67 568.798 1107.33 569.598 1093.33C570.798 1070.93 562.531 1055.87 532.131 1024.67C523.464 1015.87 514.931 1006.53 512.931 1004C510.931 1001.47 508.264 998.267 507.064 996.8C503.598 992.933 495.331 976.667 495.331 973.6C495.331 972 494.798 970.4 493.998 970C493.198 969.467 492.664 960 492.664 945.867C492.664 933.067 492.131 922.667 491.464 922.667C490.798 922.667 489.598 923.6 488.664 924.667Z" fill="#FF0000"/>
                                        <path d="M176.669 928.4C170.269 932.933 152.669 950.4 152.669 952.267C152.669 952.933 151.203 955.733 149.336 958.667C147.469 961.6 146.403 964 146.803 964C147.336 964 147.069 964.8 146.269 965.733C145.469 966.667 143.869 972.267 142.669 978C140.803 987.067 140.669 990.133 142.003 998.667C145.069 1017.73 155.203 1036.8 172.003 1054.53C176.536 1059.33 182.536 1066 185.469 1069.33C188.269 1072.67 192.269 1076.8 194.136 1078.67C201.203 1085.6 212.669 1103.6 212.669 1108C212.669 1109.33 213.336 1110.93 214.003 1111.33C214.803 1111.87 215.336 1121.33 215.336 1135.47C215.336 1148.27 215.603 1158.67 216.003 1158.67C216.936 1158.67 222.403 1155.6 223.336 1154.67C223.736 1154.27 226.136 1152.4 228.669 1150.67C239.336 1143.6 248.403 1132.93 254.936 1120.13C256.669 1116.8 258.003 1113.2 258.003 1111.87C258.003 1110.53 258.669 1109.07 259.336 1108.67C260.136 1108.13 260.669 1101.07 260.669 1092C260.669 1082.93 260.136 1075.87 259.336 1075.33C258.669 1074.93 258.003 1073.47 258.003 1072.13C258.003 1068.93 251.736 1056.8 248.669 1054C247.203 1052.67 246.003 1051.07 246.003 1050.27C246.003 1049.6 241.869 1044.8 236.936 1039.47C214.536 1016.27 198.003 998 198.003 996.533C198.003 995.733 197.203 994.267 196.269 993.467C195.203 992.667 193.069 989.2 191.469 985.733C189.736 982.133 187.736 978.133 186.936 976.667C186.136 975.2 185.203 963.333 184.936 948.933C184.669 935.2 184.003 924 183.469 924.133C183.069 924.133 180.003 926.133 176.669 928.4Z" fill="#FF0000"/>
                                        <path d="M329.334 927.6C318.401 934.8 306.401 948.533 300.534 960.933C295.067 972.4 294.934 972.933 294.801 987.333C294.667 998.933 295.201 1003.33 297.201 1008C306.267 1029.73 313.334 1039.6 338.534 1065.33C353.867 1081.07 359.334 1088.13 364.267 1098.67C369.334 1109.47 370.001 1113.47 370.001 1134.8C370.001 1146.4 370.534 1156.13 371.201 1156.53C371.734 1156.93 373.734 1156.13 375.334 1154.67C377.067 1153.2 378.934 1152 379.734 1152C381.734 1152 399.201 1134.53 403.067 1128.67C407.201 1122.53 411.601 1113.33 413.867 1106.53C415.601 1100.93 415.867 1076.93 414.134 1073.6C413.467 1072.4 411.601 1068.4 410.001 1064.8C405.867 1055.33 399.201 1046.93 379.867 1026.67C358.001 1003.73 350.001 994.533 350.001 992.4C350.001 991.467 349.601 990.667 348.934 990.667C348.401 990.667 346.801 988.4 345.467 985.6C344.134 982.933 342.534 979.6 341.867 978.4C341.201 977.067 340.667 974.8 340.667 973.467C340.667 972 340.134 970.4 339.334 970C338.534 969.467 338.001 960.267 338.001 946.533C338.001 929.333 337.601 924 336.401 924.133C335.467 924.133 332.267 925.733 329.334 927.6Z" fill="#FF0000"/>
                                        <path d="M250.534 1227.2C248.267 1228 245.6 1229.33 244.534 1230.13C243.467 1230.93 241.334 1232.13 239.734 1232.53C236.4 1233.6 224.667 1246.27 224.667 1248.93C224.667 1249.73 223.867 1251.07 223.067 1251.6C217.6 1255.07 217.467 1256.93 216.8 1382.67C216 1502 216 1503.33 213.2 1507.33C211.734 1509.47 209.467 1513.47 208.134 1516C206.934 1518.53 204.4 1523.07 202.667 1526C200.8 1528.93 198.4 1533.47 197.067 1536C195.867 1538.53 194.4 1540.93 194 1541.33C193.6 1541.73 192.134 1544.13 190.934 1546.67C189.6 1549.2 187.2 1553.73 185.334 1556.67C183.6 1559.6 180.667 1564.67 178.934 1568C169.2 1586.13 167.067 1590.13 165.734 1591.73C164.934 1592.67 162.934 1596 161.334 1599.07C155.867 1609.47 149.067 1622 144.8 1629.07C142.534 1632.93 140.667 1636.67 140.667 1637.33C140.667 1638.13 140.134 1638.67 139.334 1638.67C138.667 1638.67 138 1639.87 138 1641.33C138 1642.8 137.467 1644 136.8 1644C136.134 1644 135.334 1645.07 134.934 1646.27C134.534 1647.6 132 1652.27 129.467 1656.67C123.734 1666.67 118.4 1676.27 114.667 1683.6C113.067 1686.67 111.2 1690 110.4 1690.93C109.734 1691.87 107.6 1695.33 105.867 1698.67C104.134 1702 102.4 1704.93 102 1705.33C101.6 1705.73 99.6002 1709.33 97.6002 1713.33C95.6002 1717.33 92.5335 1723.07 90.8002 1726C85.6002 1735.07 80.4002 1744.4 77.4669 1750C75.8669 1752.93 74.2669 1755.6 73.8669 1756C73.4669 1756.4 72.6669 1757.6 72.2669 1758.67C71.7335 1759.73 70.1335 1762.67 68.6669 1765.07C67.2002 1767.47 63.6002 1773.73 60.8002 1779.07C58.0002 1784.4 53.4669 1792.53 50.8002 1797.07C48.1335 1801.73 46.0002 1806.13 46.0002 1806.8C46.0002 1807.47 45.6002 1808 44.9335 1808C44.4002 1808 42.9335 1810.27 41.6002 1813.07C40.4002 1815.73 37.2002 1821.6 34.8002 1826C27.0669 1839.47 24.4002 1844.27 19.3335 1854.4C16.5335 1859.73 13.4669 1864.93 12.6669 1866C11.7335 1867.07 11.4669 1868 12.0002 1868C12.6669 1868 12.1335 1869.07 11.0669 1870.27C10.0002 1871.6 8.40019 1875.33 7.46686 1878.67C6.53353 1882 5.20019 1885.87 4.66686 1887.33C3.06686 1891.2 2.00019 1897.73 0.933528 1910.67C-0.399806 1926.93 2.00019 1957.73 4.80019 1959.47C5.46686 1959.87 6.00019 1961.47 6.00019 1963.2C6.00019 1964.8 7.06686 1968.53 8.53353 1971.47C9.86686 1974.27 12.1335 1979.07 13.4669 1982C20.6669 1997.87 43.0669 2024 58.6669 2034.67C66.4002 2040 87.0669 2050.67 89.6002 2050.67C90.5335 2050.67 92.4002 2051.2 93.7335 2051.87C96.6669 2053.33 108.8 2056.8 117.734 2058.53C127.734 2060.53 596.534 2060.53 607.867 2058.53C612.4 2057.73 617.867 2056.53 620 2055.73C622.267 2055.07 625.467 2054.13 627.334 2053.73C629.2 2053.47 632 2052.53 633.734 2051.87C635.334 2051.2 638.134 2050 640 2049.33C651.067 2044.93 652.4 2044.27 658.4 2040.93C660 2040.13 661.6 2039.07 662 2038.67C662.4 2038.27 665.334 2036.27 668.534 2034.13C676.134 2029.2 697.867 2007.47 702.8 1999.87C704.934 1996.67 706.934 1993.73 707.334 1993.33C707.734 1992.93 710 1988.4 712.534 1983.33C714.934 1978.13 717.467 1972.93 718.134 1971.73C718.8 1970.4 719.334 1968.13 719.334 1966.8C719.334 1965.33 720 1963.73 720.667 1963.33C721.467 1962.93 722 1960.67 722 1958.53C722 1956.27 722.8 1952.93 723.867 1950.93C728.934 1940.93 726.667 1895.73 720.534 1883.73C719.867 1882.4 719.334 1880.4 719.334 1879.33C719.334 1878.27 718.8 1876.27 718.134 1874.93C717.467 1873.73 716.267 1870.8 715.334 1868.67C714.4 1866.4 712.8 1863.2 711.867 1861.33C710.8 1859.47 708.134 1854.67 705.867 1850.67C703.734 1846.67 699.867 1839.73 697.334 1835.33C694.8 1830.93 691.467 1824.93 690 1822C688.534 1819.07 686.134 1814.8 684.8 1812.67C681.6 1807.33 677.2 1799.73 672.267 1790.67C670 1786.67 666.934 1781.2 665.467 1778.67C663.867 1776.13 661.734 1772.13 660.667 1770C659.6 1767.73 658.4 1765.73 658 1765.33C657.6 1764.93 656.4 1762.8 655.334 1760.67C654.267 1758.4 652.4 1755.2 651.2 1753.33C648.934 1749.87 644 1741.07 638 1730C636 1726.27 632.534 1720.27 630.267 1716.67C628.134 1712.93 624.134 1706.13 621.6 1701.33C619.067 1696.53 615.734 1690.53 614.134 1688C612.667 1685.47 610.934 1682.4 610.4 1681.33C609.867 1680.27 607.734 1676.27 605.6 1672.67C603.334 1668.93 600 1662.93 598 1659.33C596 1655.6 593.2 1650.53 591.6 1648C590 1645.47 587.734 1641.2 586.534 1638.67C585.2 1636.13 582.534 1631.6 580.667 1628.67C578.667 1625.73 576.667 1622.4 576.267 1621.33C575.734 1620.27 574.134 1617.33 572.667 1614.93C571.2 1612.53 567.6 1606.27 564.8 1600.93C562 1595.6 557.867 1588.27 555.6 1584.67C553.334 1580.93 550.134 1575.6 548.667 1572.67C545.467 1566.53 539.334 1555.6 532.667 1544.4C530.134 1540.13 526.8 1534.27 525.334 1531.33C519.734 1520.8 514.934 1512.53 510.934 1506.8L506.934 1500.93L507.867 1456.13C510 1344.13 510.4 1264.4 508.934 1263.47C508 1262.93 507.334 1261.33 507.334 1260C507.334 1253.6 493.467 1236.67 484.4 1231.87C471.334 1225.2 475.6 1225.33 361.334 1225.47C285.6 1225.6 253.467 1226.13 250.534 1227.2ZM407.2 1325.87C408.4 1326.67 408.534 1348.53 407.867 1421.87C407.067 1508.67 407.067 1517.33 409.067 1521.33C410.4 1523.73 411.334 1526.53 411.334 1527.6C411.334 1528.53 411.867 1529.33 412.534 1529.33C413.2 1529.33 414 1530.4 414.534 1531.6C415.467 1534.53 419.734 1541.87 422 1544.67C422.934 1545.73 423.2 1546.67 422.667 1546.67C422 1546.67 422.4 1547.73 423.467 1548.93C424.534 1550.27 426.267 1552.93 427.334 1554.93C428.267 1557.07 429.6 1558.67 430.267 1558.67C430.8 1558.67 431.334 1559.87 431.334 1561.33C431.334 1562.8 431.734 1564 432.4 1564C432.934 1564 434.134 1566 435.2 1568.27C436.267 1570.67 438.4 1574.4 440 1576.67C441.6 1578.8 444.934 1584.8 447.334 1590C449.867 1595.07 453.734 1602 455.867 1605.33C458.134 1608.67 459.867 1611.73 459.734 1612.27C459.6 1612.67 460.267 1613.87 461.334 1614.67C462.4 1615.6 463.334 1617.47 463.334 1618.8C463.334 1620.27 464 1621.33 464.667 1621.33C465.467 1621.33 466 1622.13 466 1623.2C466 1624.27 466.4 1625.33 467.067 1625.6C467.6 1625.73 469.467 1628.93 471.334 1632.67C473.067 1636.27 476.4 1642 478.667 1645.33C484.534 1654.27 486 1657.07 486 1659.33C486 1660.4 486.4 1661.33 487.067 1661.33C487.6 1661.33 488.8 1663.07 489.734 1665.33C490.667 1667.47 492.934 1671.33 494.667 1674C496.534 1676.53 497.6 1678.67 497.067 1678.67C496.667 1678.67 497.2 1679.73 498.267 1680.93C499.334 1682.27 501.067 1685.33 502.134 1687.6C503.2 1690 504.4 1692 504.934 1692C505.6 1692 506 1692.93 506 1694C506 1695.07 506.667 1696 507.334 1696C508.134 1696 508.667 1697.2 508.667 1698.67C508.667 1700.13 509.334 1701.33 510 1701.33C510.8 1701.33 511.334 1702.53 511.334 1703.87C511.334 1705.2 512.267 1706.67 513.334 1707.2C514.4 1707.6 515.334 1709.07 515.334 1710.4C515.334 1711.87 516.267 1713.73 517.334 1714.67C518.4 1715.6 521.2 1720 523.467 1724.53C529.467 1736.53 531.867 1740.53 533.6 1741.73C534.534 1742.27 534.934 1743.6 534.534 1744.67C534 1745.73 534.4 1746.67 535.067 1746.67C536.534 1746.67 540.667 1754 540.667 1756.67C540.667 1757.6 541.6 1759.07 542.667 1760C543.734 1760.93 546.267 1764.93 548.267 1769.2C550.267 1773.33 553.2 1778.53 554.934 1780.8C556.667 1783.07 558 1785.6 558 1786.4C558 1787.33 558.667 1788 559.334 1788C561.734 1788 560.8 1794.53 558.134 1796C554.8 1797.73 537.067 1797.73 536 1796C535.6 1795.2 534 1794.67 532.534 1794.67C528.534 1794.67 514.934 1782.27 511.334 1775.2C508.8 1770.27 507.867 1769.33 500.667 1764.53C488.667 1756.4 482.267 1754.27 469.734 1754C458 1753.73 456.8 1754 443.734 1760.27C437.734 1763.2 428.667 1770.8 428.667 1772.93C428.667 1775.33 409.6 1793.47 404.8 1795.6C401.6 1797.07 395.867 1797.87 387.334 1797.87C376.134 1798 373.734 1797.6 366.934 1794.4C359.2 1790.67 349.2 1781.87 343.334 1773.33C338 1765.73 335.867 1763.87 324.134 1757.47C315.2 1752.53 303.734 1751.33 290 1754C287.6 1754.53 279.734 1758.13 274 1761.47C270.267 1763.6 259.334 1774.8 259.334 1776.4C259.334 1778.27 242 1794.67 240.134 1794.67C239.067 1794.67 238 1795.33 237.734 1796.27C236.934 1798.67 210.934 1798.53 203.334 1796.13C200 1795.07 195.867 1792.8 193.867 1791.07C192 1789.33 189.867 1788 189.2 1788C188.4 1788 184.934 1785.2 181.467 1781.87C176.134 1776.53 175.334 1775.07 176 1771.87C176.534 1769.73 177.467 1768 178.134 1768C178.8 1768 179.334 1767.07 179.334 1766C179.334 1764.93 181.334 1761.07 183.734 1757.6C186.134 1754.13 189.6 1748.27 191.334 1744.67C193.2 1740.93 195.067 1737.73 195.734 1737.6C196.267 1737.33 196.667 1736.27 196.667 1735.2C196.667 1734.13 197.334 1733.33 198 1733.33C198.8 1733.33 199.334 1732.13 199.334 1730.67C199.334 1729.2 200.267 1727.6 201.334 1727.2C202.4 1726.67 203.334 1725.2 203.334 1723.87C203.334 1722.53 203.734 1721.33 204.4 1721.33C204.934 1721.33 206 1720 206.8 1718.27C213.734 1704.53 219.734 1693.73 221.334 1692.53C222.4 1691.73 223.334 1690 223.334 1688.8C223.334 1687.6 224 1686.67 224.667 1686.67C225.467 1686.67 226 1685.47 226 1684C226 1682.53 226.667 1681.33 227.334 1681.33C228.134 1681.33 228.667 1680.13 228.667 1678.67C228.667 1677.2 229.334 1676 230 1676C230.8 1676 231.334 1675.2 231.334 1674.13C231.334 1673.07 231.734 1672 232.4 1671.73C233.334 1671.33 236.4 1666.13 242.667 1653.6C244.667 1649.87 246.8 1646.67 247.467 1646.67C248.134 1646.67 248.667 1645.47 248.667 1644C248.667 1642.53 249.334 1641.33 250 1641.33C250.8 1641.33 251.334 1640.13 251.334 1638.67C251.334 1637.2 252 1636 252.667 1636C253.467 1636 254 1635.07 254 1634C254 1632.93 255.334 1630.53 257.067 1628.53C258.667 1626.67 259.867 1624.67 259.734 1624.27C259.6 1623.73 260.267 1622.4 261.2 1621.33C262.134 1620.27 264.267 1616.53 266 1612.93C267.734 1609.47 269.6 1606.67 270.267 1606.67C270.8 1606.67 271.334 1605.73 271.334 1604.67C271.334 1602.4 273.6 1598 276.534 1594.27C277.6 1593.07 278 1592 277.467 1592C277.067 1592 278.667 1589.2 281.067 1585.6C283.467 1582.13 286.8 1576.27 288.667 1572.67C290.534 1568.93 292.267 1565.73 292.667 1565.33C293.067 1564.93 294.534 1562.4 295.734 1559.6C297.067 1556.93 298.667 1554.67 299.334 1554.67C300.134 1554.67 300.667 1553.47 300.667 1552C300.667 1550.53 301.334 1549.33 302 1549.33C302.8 1549.33 303.334 1548.13 303.334 1546.67C303.334 1545.2 304 1544 304.667 1544C305.467 1544 306 1542.8 306 1541.33C306 1539.87 306.534 1538.67 307.2 1538.67C307.867 1538.67 310 1535.33 311.867 1531.33C313.867 1527.33 316.134 1523.73 316.8 1523.33C317.6 1522.8 318 1485.33 318 1425.73C318 1356.53 318.4 1328.53 319.467 1327.2C320.4 1326.13 324.667 1325.33 331.067 1325.07C350.8 1324.27 405.6 1324.93 407.2 1325.87Z" fill="#FF0000"/>
                                      </svg>

                                    </button>

                                    <!--Informe qual a temperatura (em ºC - graus Celsius) de uso do produto:-->
                                    <b-popover
                                      custom-class=''
                                      :target='`${roleProduct._id}_${roleProduct.product._id}_temperature`'
                                      placement='top'
                                      triggers='hover'
                                    >
                                      <span class='label' v-if='roleProduct.product.termsofuses && roleProduct.product.termsofuses.temperature'>
                                        Clique para editar a temperatura (em ºC - graus Celsius) de uso do produto
                                      </span>
                                      <span v-else class='label'>
                                        Clique para cadastrar a temperatura (em ºC - graus Celsius) de uso do produto
                                      </span>
                                    </b-popover>
                                    <button
                                      :id='`${roleProduct._id}_${roleProduct.product._id}_temperature`'
                                      class='btn-termsofuses'
                                      :class="roleProduct.product.termsofuses && roleProduct.product.termsofuses.temperature ? 'btn-termsofuses' : 'btn-termsofuses-not-filled'"
                                      @click="showWorkersModal(roleProduct.product, 'temperatureModal')"
                                    >
                                      <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24'
                                           fill='none'>
                                        <path
                                          d='M22.5 13.5H18C17.6023 13.4996 17.221 13.3414 16.9398 13.0602C16.6586 12.779 16.5004 12.3977 16.5 12V4.5C16.5004 4.1023 16.6586 3.721 16.9398 3.43978C17.221 3.15856 17.6023 3.0004 18 3H22.5V4.5H18V12H22.5V13.5Z'
                                          fill='#022245' />
                                        <path
                                          d='M13.5 4.5C14.3284 4.5 15 3.82843 15 3C15 2.17157 14.3284 1.5 13.5 1.5C12.6716 1.5 12 2.17157 12 3C12 3.82843 12.6716 4.5 13.5 4.5Z'
                                          fill='#022245' />
                                        <path
                                          d='M7.50001 15.138V9H6V15.138C5.49959 15.3149 5.07784 15.6631 4.80928 16.1209C4.54072 16.5787 4.44265 17.1167 4.53241 17.6398C4.62216 18.1629 4.89396 18.6375 5.29976 18.9796C5.70556 19.3217 6.21924 19.5093 6.75 19.5093C7.28077 19.5093 7.79445 19.3217 8.20025 18.9796C8.60605 18.6375 8.87785 18.1629 8.9676 17.6398C9.05736 17.1167 8.95929 16.5787 8.69073 16.1209C8.42217 15.6631 8.00042 15.3149 7.50001 15.138Z'
                                          fill='#022245' />
                                        <path
                                          d='M6.75065 22.5C5.71713 22.5012 4.70631 22.1969 3.84511 21.6255C2.98391 21.0541 2.31072 20.241 1.91009 19.2883C1.50945 18.3356 1.39923 17.2858 1.59325 16.2706C1.78728 15.2555 2.27691 14.3203 3.00065 13.5825V5.25C3.00065 4.25544 3.39574 3.30161 4.099 2.59835C4.80226 1.89509 5.75609 1.5 6.75065 1.5C7.74521 1.5 8.69904 1.89509 9.4023 2.59835C10.1056 3.30161 10.5007 4.25544 10.5007 5.25V13.5825C11.2244 14.3203 11.714 15.2555 11.9081 16.2706C12.1021 17.2858 11.9919 18.3356 11.5912 19.2883C11.1906 20.241 10.5174 21.0541 9.6562 21.6255C8.795 22.1969 7.78417 22.5012 6.75065 22.5ZM6.75065 3C6.1541 3.0006 5.58215 3.23784 5.16032 3.65967C4.73849 4.0815 4.50125 4.65345 4.50065 5.25V14.2373L4.25165 14.4615C3.68531 14.9677 3.28604 15.6339 3.10669 16.372C2.92734 17.1101 2.97636 17.8853 3.24727 18.5949C3.51818 19.3046 3.9982 19.9152 4.6238 20.346C5.24939 20.7768 5.99107 21.0075 6.75065 21.0075C7.51024 21.0075 8.25191 20.7768 8.87751 20.346C9.50311 19.9152 9.98313 19.3046 10.254 18.5949C10.5249 17.8853 10.574 17.1101 10.3946 16.372C10.2153 15.6339 9.81599 14.9677 9.24965 14.4615L9.00065 14.2373V5.25C9.00006 4.65345 8.76281 4.0815 8.34098 3.65967C7.91916 3.23784 7.34721 3.0006 6.75065 3Z'
                                          fill='#022245' />
                                      </svg>
                                    </button>

                                    <!--Importar condições de uso de outro produto-->
                                    <b-popover
                                      custom-class=''
                                      :target='`${roleProduct._id}_${roleProduct.product._id}_importTermsOfUse`'
                                      placement='top'
                                      triggers='hover'
                                    >
                                      <span class='label'>
                                        Clique para importar as condições de uso de outro produto para este produto
                                      </span>
                                    </b-popover>
                                    <button
                                      :id='`${roleProduct._id}_${roleProduct.product._id}_importTermsOfUse`'
                                      class='btn-import-termsofuses'
                                      @click='showImportTermsOfUse(roleProduct.product)'
                                    >
                                      <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                        <path
                                          d='M10 2C10.5523 2 11 2.44772 11 3V13.5858L14.2929 10.2929C14.6834 9.90237 15.3166 9.90237 15.7071 10.2929C16.0976 10.6834 16.0976 11.3166 15.7071 11.7071L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071L4.29289 11.7071C3.90237 11.3166 3.90237 10.6834 4.29289 10.2929C4.68342 9.90237 5.31658 9.90237 5.70711 10.2929L9 13.5858V3C9 2.44772 9.44772 2 10 2Z'
                                          fill='#04A8F3' />
                                      </svg>
                                    </button>
                                    </section>

                                    <button
                                      class="btn-unlink-product ml-2 mb-1"
                                       @click="showUnlinkProductModal(roleProduct.product, sectorRole.role)"
                                    >
                                      <span>Desvincular produto</span>
                                    </button>
                                  </section>
                                </section>

                                <section class='pt-2 pb-3 px-2' style='background: #F3F3F4; margin-top: -1px'>
                                  <section class='w-100 d-flex align-content-end justify-content-between flex-wrap mt-1 product-content'>
                                    <section class="percentage_produto-cas_agent">
                                      <section class="header p-2 d-flex align-items-center justify-content-around">
                                        <section class="text-center w-50">
                                          <span>% do agente no produto</span>
                                        </section>
                                        <section class="text-center w-50">
                                          <span>CAS: Agente</span>
                                        </section>
                                      </section>

                                      <section
                                        class="header p-2 d-flex align-items-center justify-content-around"
                                        v-for='(legalSearch, l) in roleProduct.product.legalSearches'
                                        :key='l._id'
                                      >
                                        <section class="mr-5 text-center w-50">
                                          <p v-if="legalSearch.percentage">{{legalSearch.percentage}}%</p>
                                          <p v-else>-</p>
                                        </section>
                                        <section  class="mr-5 text-center w-50">
                                          <p class=" ">{{legalSearch.name}}</p>
                                        </section>
                                      </section>
                                    </section>
                                    <section class="detalhes-produto">
                                      <section class="header p-2 d-flex align-items-center justify-content-around">
                                        <section class="text-center w-100">
                                          <span>Detalhes do produto</span>
                                        </section>
                                      </section>

                                      <section>
                                        <section class="w-100 d-flex header p-2">
                                          <section class="w-50 mr-3">
                                            <span>Descrição:</span>
                                          </section>
                                          <section class="w-50 ">
                                            <p class="text-center">{{ roleProduct.product.description }}</p>
                                          </section>
                                        </section>

                                        <section class="w-100 d-flex header p-2">
                                          <section class="w-50 mr-3">
                                            <span>Estado físico:</span>
                                          </section>
                                          <section class="w-50 ">
                                            <p v-if='roleProduct.product && roleProduct.product.physicalState' class="text-center">
                                              {{ physicalProductStates.find((x) => x.key == roleProduct.product.physicalState).value }}
                                            </p>
                                            <p v-else class="text-center">Não informado</p>
                                          </section>
                                        </section>

                                        <section class="w-100 d-flex header p-2">
                                          <section class="w-50 mr-3">
                                            <span>FISPQ:</span>
                                          </section>
                                          <section class="w-50 ">
                                            <p v-if='roleProduct.product && roleProduct.product.urlFISPQ' class="text-center">
                                              <a
                                                class='file-uploaded mt-3'
                                                v-if='roleProduct.product.urlFISPQ'
                                                :href='roleProduct.product.urlFISPQ'
                                                target='_blank'
                                              >
                                                Ver arquivo anexado
                                              </a>
                                            </p>
                                            <p v-else class="text-center">Não informado</p>
                                          </section>
                                        </section>
                                      </section>
                                    </section>
                                  </section>
                                </section>
                              </section>
                            </section>
                          </section>
                        </section>

                        <section
                          class="risk-physical"
                          v-if="getRolesLegalsearches(sectorRole, 'fisico')"
                        >
                          <section class="risk-physical-text">
                            <strong class="ml-3">Riscos Físicos</strong>
                          </section>
                          <section class="mr-3">
                            <button
                              :id="`${sectorRole.role._id}_hover`"
                              class='pointer btn-expand-collapse-navy-blue'
                              :class="sectorRole.physicalRiskOpen ? ' ' : 'pulse-gro-chevron-up'"
                              @click="toggleRiskOpen(sectorRole, 'physicalRiskOpen')"
                            >
                              <span>{{sectorRole.physicalRiskOpen ? 'Recolher informações' : 'Expandir informações'}}</span>
                            </button>
                          </section>
                        </section>
                        <section v-if="sectorRole.physicalRiskOpen && getRolesLegalsearches(sectorRole, 'fisico')" class="transition" style="margin-left: 125px">
                          <section style="margin-top: 1px">
                            <table class="text-center w-100 table-bordered">
                              <thead>
                                <tr class="physical-agents-header">
                                  <th class="p-3">CAS: Agente</th>
                                  <th class="p-2">ACGIH</th>
                                  <th class="p-2">NR 15</th>
                                  <th class="p-2">eSocial</th>
                                  <th class="p-2">Decreto 3048/99</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="agent in getAgentsByRisk(sectorRole, 'fisico')"
                                  :key="agent._id"
                                >
                                  <td class="p-3">
                                    <strong>{{ model.getsearchId('searchId', agent)}}</strong>
                                  </td>
                                  <td class="p-2">
                                    {{ (agent.acgih && agent.acgih.group) ? agent.acgih.group : '-' }}
                                  </td>
                                  <td class="p-2">
                                    {{ agent.nameAttachment11 || (agent.attachment11 && agent.attachment11.group) || '-' }}
                                  </td>
                                  <td class="p-2">
                                    {{ agent.nameEsocial || (agent.esocial && agent.esocial.group) || '-' }}
                                  </td>
                                  <td class="p-2">
                                    {{ agent.nameDecree || (agent.decree3048 && agent.decree3048.group) || '-' }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </section>
                        </section>

                        <section
                          class="risk-biological"
                          v-if="getRolesLegalsearches(sectorRole, 'biologico')"
                        >
                          <section class="risk-biological-text">
                            <strong class="ml-3">Riscos Biológicos</strong>
                          </section>
                          <section class="mr-3">
                            <button
                              :id="`${sectorRole.role._id}_hover`"
                              class='pointer btn-expand-collapse-navy-blue'
                              :class="sectorRole.biologicalRiskOpen ? ' ' : 'pulse-gro-chevron-up'"
                              @click="toggleRiskOpen(sectorRole, 'biologicalRiskOpen')"
                            >
                              <span>{{sectorRole.biologicalRiskOpen ? 'Recolher informações' : 'Expandir informações'}}</span>
                            </button>
                          </section>
                        </section>
                        <section v-if="sectorRole.biologicalRiskOpen && getRolesLegalsearches(sectorRole, 'biologico')" class="transition" style="margin-left: 125px">
                          <section style="margin-top: 1px">
                            <table class="text-center w-100 table-bordered">
                              <thead>
                              <tr class="biological-agents-header">
                                <th class="p-3">CAS: Agente</th>
                                <th class="p-2">ACGIH</th>
                                <th class="p-2">NR 15</th>
                                <th class="p-2">eSocial</th>
                                <th class="p-2">Decreto 3048/99</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr
                                v-for="agent in getAgentsByRisk(sectorRole, 'biologico')"
                                :key="agent._id"
                              >
                                <td class="p-3">
                                  <strong>{{ model.getsearchId('searchId', agent)}}</strong>
                                </td>
                                <td class="p-2">
                                  {{ (agent.acgih && agent.acgih.group) ? agent.acgih.group : '-' }}
                                </td>
                                <td class="p-2">
                                  {{ agent.nameAttachment11 || (agent.attachment11 && agent.attachment11.group) || '-' }}
                                </td>
                                <td class="p-2">
                                  {{ agent.nameEsocial || (agent.esocial && agent.esocial.group) || '-' }}
                                </td>
                                <td class="p-2">
                                  {{ agent.nameDecree || (agent.decree3048 && agent.decree3048.group) || '-' }}
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </section>
                        </section>
                      </section>
                    </section>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
      <section v-else>
        <section class="altert-content p-2 mb-2">
          <p class="mb-2">
            <strong>Aviso Importante: </strong>
            <span>Alteração na Hierarquia da Empresa</span>
          </p>
          <p class="mb-1">Informamos que, a partir de <strong>{{ formatDate(dateNewFormatCompanyHierarchy) }}</strong>, o formato da hierarquia da empresa foi atualizado.</p>
          <p class="mb-1">Todas as novas empresas criadas já seguirão automaticamente o novo modelo de hierarquia.</p>
          <p class="mb-1">As empresas criadas antes desta data permanecerão com o formato anterior e não poderão ser editadas.</p>
          <p class="mb-1">Essa mudança tem como objetivo padronizar a estrutura e trazer mais agilidade no gerenciamento das informações.</p>
        </section>
        <section class='mt-1 mb-5' v-if='companyLegalConsultation'>
          <section :id='companyLegalConsultation._id'>
            <section
              class='company d-flex align-items-center justify-content-between'
            >
              <section class='d-flex align-items-center justify-content-start h-100'>
                <span class='name ml-3'>Empresa: {{ companyLegalConsultation.name }}</span>
              </section>
            </section>
          </section>

          <section class='transition' v-if='companyLegalConsultation.open'>
            <section v-for='unit in companyLegalConsultation.units' :key='unit._id'>
              <section style='margin-left: 25px' :id='unit._id'>
                <section
                  class='unit d-flex align-items-center justify-content-between'
                >
                  <section class='d-flex align-items-center justify-content-start h-100'>
                    <span class='name ml-3'>Unidade: {{ unit.name }}</span>
                  </section>
                </section>
              </section>

              <section class='transition' v-if='unit.open'>
                <section v-for='sector in unit.sectors' :key='sector._id'>
                  <section style='margin-left: 50px' :id='sector._id'>
                    <section
                      class='sector d-flex align-items-center justify-content-between'
                    >
                      <section class='d-flex align-items-center justify-content-start h-100'>
                        <span class='name ml-3'>Setor: {{ sector.name }}</span>
                      </section>
                    </section>
                  </section>

                  <section class='transition' v-if='sector.open'>
                    <section v-for='role in sector.roles' :key='role._id'>
                      <section :id='role._id' style='margin-left: 75px'>
                        <section
                          class='role d-flex align-items-center justify-content-between'
                        >
                          <section class='d-flex align-items-center justify-content-start h-100'>
                            <span class='name ml-3'>Cargo: {{ role.name }}</span>
                          </section>
                        </section>
                      </section>

                      <section class='transition' v-if='role.open'>
                        <section v-for='product in role.products' :key='product._id'>
                          <section
                            :id='product._id'
                            class='product'
                            style='margin-left: 100px'
                          >
                            <section >
                              <section
                                class='product d-flex align-items-center justify-content-between'
                                style='background: #DADADA'
                              >
                                <section class='d-flex align-items-center justify-content-start h-100'>
                                  <span class='name ml-3'>Produto: {{ product.name }}</span>
                                </section>

                                <section class='d-flex align-items-center justify-content-between mr-5'>
                                  <section>
                                  </section>
                                </section>
                              </section>

                              <section class='pt-2 pb-3  pl-3 pr-5' style='background: #F3F3F4; margin-top: -1px'>
                                <section class='w-100 d-flex align-content-end justify-content-between'>
                                  <section class='header-product'>
                                    <strong>CAS: Agente</strong>
                                  </section>

                                  <section class='header-product'>
                                    <strong>Descrição <br />do Produto</strong>
                                  </section>

                                  <section class='header-product'>
                                    <strong>Estado físico <br/> do produto</strong>
                                  </section>

                                  <section class='header-product'>
                                    <strong>FISPQ</strong>
                                  </section>

                                  <section class='header-product'>
                                    <strong>% do agente <br /> no produto</strong>
                                  </section>

                                  <section class='header-product-actions'>
                                    <strong>Ações</strong>
                                  </section>
                                </section>

                                <section class='w-100 d-flex align-content-end justify-content-between mt-1'>
                                  <section class='body-product d-flex flex-column'>
                                    <section
                                      v-for='(legalSearch, l) in product.legalSearches'
                                      :key='l._id'
                                      class='mb-2'
                                    >
                                      <span class='text-data-product'>{{ legalSearch.name }}</span>
                                    </section>
                                  </section>

                                  <section class='body-product'>
                                    <span class='text-data-product'>{{ product.description }}</span>
                                  </section>

                                  <section class='body-product'>
                                  <span class='text-data-product' v-if='product.physicalState'>
                                    {{ physicalProductStates.find((x) => x.key == product.physicalState).value }}
                                  </span>
                                    <span v-else class='text-data-product'>-</span>
                                  </section>

                                  <section class='body-product'>
                                    <a
                                      class='file-uploaded mt-3'
                                      v-if='product.urlFISPQ'
                                      :href='product.urlFISPQ'
                                      target='_blank'
                                    >
                                      Ver arquivo anexado
                                    </a>
                                    <strong v-else class='text-data-product'>-</strong>
                                  </section>

                                  <section class='body-product'>
                                    <section
                                      v-for="(legalSearch, l) in product.legalSearches"
                                      :key="l._id"
                                      class="mb-2"
                                    >
                                    <span class="text-data-product">
                                      {{  legalSearch.percentage ? legalSearch.percentage + '%' : '-' }}
                                    </span>
                                    </section>
                                  </section>

                                  <section class='body-product-actions d-flex flex-wrap justify-content-end'>
                                    <p>-</p>
                                  </section>
                                </section>
                              </section>
                            </section>
                            <section
                              v-if='product.termsofuses'
                              style='background: #F3F3F4; margin-top: -1px;'
                            >
                              <section>
                                <hr />
                              </section>

                              <section class='d-flex align-items-center justify-content-start h-100'>
                                <span class='name ml-3'>Condição de uso do produto: {{ product.name }}</span>
                              </section>

                              <section class='d-flex justify-content-between flex-wrap ml-3 mt-2'>
                                <section class='mr-3'>
                                  <span class='description-title'>Temperatura °C</span> <br />
                                  <span v-if='product.termsofuses.temperature'
                                        class='description-text'>{{ product.termsofuses.temperature }}</span>
                                  <span v-else class='description-text'>-</span>
                                </section>

                                <section class='mr-3'>
                                  <span class='description-title'>Nível de ventilação</span>
                                  <br />
                                  <p
                                    v-if='product.termsofuses.ventilationWorkEnvironmentGeneral'
                                    class='description-text'
                                    style='max-width: 150px!important;'
                                  >
                                    {{ ventilationLevels.find((x) => x.key == product.termsofuses.ventilationWorkEnvironmentGeneral).value }}
                                  </p>

                                  <p v-else class='description-text' style='max-width: 150px!important;'>-</p>
                                </section>

                                <section class='mr-3'>
                                  <span class='description-title'>Nível de controle <br/> da ventilação</span>
                                  <br />
                                  <p
                                    v-if='product.termsofuses.ventilationInstalledSpecificallyForTheProductionProcess'
                                    class='description-text'
                                    style='max-width: 150px!important;'
                                  >
                                    {{ product.termsofuses.isCustomControlLevel
                                      ? `Nível de Controle Personalizado (nível ${product.termsofuses.ventilationInstalledSpecificallyForTheProductionProcess} de 6)`
                                      : optionsVentilationIdentified.find((x) => x.key == product.termsofuses.ventilationInstalledSpecificallyForTheProductionProcess).value }}
                                  </p>

                                  <p v-else class='description-text' style='max-width: 150px!important;'>-</p>
                                </section>

                                <section class='mr-3'>
                                  <span class='description-title'>Qntd. Utilizada</span> <br />

                                  <span class='description-text' v-if='product.termsofuses.quantityUsed'>
                                  {{ optionsQuantityUsed.find((x) => x.key == product.termsofuses.quantityUsed).value }}
                                </span>

                                  <span v-else class='description-text'>
                                  -
                                </span>
                                </section>

                                <section class='mr-3'>
                                  <span class='description-title'>Frequência de <br /> Uso</span> <br />

                                  <span v-if='product.termsofuses.frequencyUse' class='description-text'>
                                  {{ optionsFrequencyUse.find((x) => x.key == product.termsofuses.frequencyUse).value }}
                                </span>

                                  <span v-else class='description-text'>
                                  -
                                </span>
                                </section>

                                <section class='mr-3'>
                                  <span class='description-title'>Tempo de <br />Exposição</span> <br />

                                  <span v-if='product.termsofuses.exposureTime' class='description-text'>
                                  {{ optionsExposureTime.find((x) => x.key == product.termsofuses.exposureTime).value }}
                                </span>

                                  <span v-else class='description-text'>
                                  -
                                </span>
                                </section>

                                <section class='mr-3'>
                                  <span class='description-title'>Qntd. de <br /> Trabalhadores <br /> Expostos</span>
                                  <br />
                                  <span class='description-text'>{{ product.termsofuses.exposedWorkers }}</span>
                                </section>

                                <section class='mr-5'>
                                  <span class='description-title'>Estado Físico  <br /> do Produto</span> <br />

                                  <span v-if='product.termsofuses.physicalStateProduct' class='description-text'>
                                  {{ physicalProductStates.find((x) => x.key == product.termsofuses.physicalStateProduct).value
                                    }}
                                </span>

                                  <span v-else class='description-text'>
                                  -
                                </span>
                                </section>

                                <section class='mr-5'>
                                  <span class='description-title'>Grau de <br/>empoeiramento</span> <br />
                                  <span v-if='product.termsofuses.degreeOfDust' class='description-text'>
                                  {{ optionsDegreeOfDust.find((x) => x.key == product.termsofuses.degreeOfDust).value
                                    }}
                                </span>

                                  <span v-else class='description-text'>
                                  -
                                </span>
                                </section>
                              </section>
                            </section>
                          </section>
                        </section>
                      </section>
                    </section>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
      <template v-slot:overlay>
        <div class='text-center loading-spinner'>
          <b-spinner
            style='width: 3rem; height: 3rem'
            variant='primary'
            label='Large Spinner'
          ></b-spinner>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import eventBus from '../../../utils/eventBus'
import AgentPercentage from '@/components/LegalSearch/Modal/AgentPercentage.vue'
import ModalConfirmAction from '@/components/ModalConfirmAction.vue'
import ProductAdd from '@/components/LegalSearch/Modal/ProductAdd.vue'
import Unit from '@/components/LegalSearch/Gro/components/Unit.vue'
import Sector from '@/components/LegalSearch/Gro/components/Sector.vue'
import Role from '@/components/LegalSearch/Gro/components/Role.vue'
import Products from '@/components/LegalSearch/Gro/components/Products.vue'
import TermsOfUse from '@/components/LegalSearch/Gro/components/TermsOfUse/TermsOfUse.vue'
import WorkersModal from '@/components/LegalSearch/Gro/components/TermsOfUse/WorkersModal.vue'
import VentilationIdentifiedModal
  from '@/components/LegalSearch/Gro/components/TermsOfUse/VentilationIdentifiedModal.vue'
import TemperatureModal from '@/components/LegalSearch/Gro/components/TermsOfUse/TemperatureModal.vue'
import QuantityUsedFrequencyExposureTimeUseModal
  from '@/components/LegalSearch/Gro/components/TermsOfUse/QuantityUsedFrequencyExposureTimeUseModal.vue'
import TabButtons from '@/components/LegalSearch/components/TabButtons.vue'
import { ventilationLevels } from '@/mocks/ventilationLevels'
import { optionsVentilationIdentified } from '@/mocks/optionsVentilationIdentified'
import { optionsExposureTime } from '@/mocks/optionsExposureTime'
import { optionsFrequencyUse } from '@/mocks/optionsFrequencyUse'
import { optionsQuantityUsed } from '@/mocks/optionsQuantityUsed'
import { physicalProductStates } from '@/mocks/physicalProductStates'
import { optionsDegreeOfDust } from '@/mocks/optionsDegreeOfDust'
import SelectRoles from '@/components/LegalSearch/Gro/components/SelectRoles.vue'
import AnalysisToolModal from '@/components/LegalSearch/AnalysisToolModal.vue'
import AnalysisPermanentExposureAndEffectiveProtection from '@/models/AnalysisPermanentExposureAndEffectiveProtection'
import Measurements from '@/components/LegalSearch/Gro/components/TermsOfUse/Measurements.vue'
import VentilationInstalledSpecificallyForTheProductionProcessModal
  from '@/components/LegalSearch/Gro/components/TermsOfUse/VentilationInstalledSpecificallyForTheProductionProcessModal.vue'
import UnlinkProductModal from '@/components/LegalSearch/Gro/components/TermsOfUse/UnlinkProductModal.vue'
import EffectiveProtection from '@/components/LegalSearch/Gro/components/EffectiveProtection.vue'
import PermanentExhibition from '@/components/LegalSearch/Gro/components/PermanentExhibition.vue'
import ImportTermsOfUse from '@/components/LegalSearch/Gro/components/TermsOfUse/ImportTermsOfUse.vue'
import ArchivedRoles from '@/components/LegalSearch/Gro/components/ArchivedRoles.vue'
import moment from 'moment/moment'
import { format } from 'date-fns'
import LegalSearchSummary from '@/models/LegalSearchSummary'


export default {
  name: 'Gro',
  components: {
    PermanentExhibition,
    EffectiveProtection,
    UnlinkProductModal,
    VentilationInstalledSpecificallyForTheProductionProcessModal,
    Measurements,
    AnalysisToolModal,
    SelectRoles,
    ArchivedRoles,
    ProductAdd,
    ModalConfirmAction,
    AgentPercentage,
    Unit,
    Sector,
    Role,
    Products,
    TermsOfUse,
    TabButtons,
    WorkersModal,
    QuantityUsedFrequencyExposureTimeUseModal,
    TemperatureModal,
    VentilationIdentifiedModal,
    ImportTermsOfUse
  },
  data() {
    return {
      analysisPermanentExposureAndEffectiveProtection: AnalysisPermanentExposureAndEffectiveProtection,
      protecaoEficazProps: null,
      functionalityProps: 1,
      questions: [],
      exposicaoPermanenteProps: null,
      userOrProduct: null,
      disabledAnalysisTool: false,
      titleRemove: '',
      descriptionRemove: '',
      loadingRemove: false,
      loading: false,
      lookingForCompany: false,
      lookingForCompanies: false,
      currentCompany: null,
      currentUnit: null,
      currentSector: null,
      currentRole: Object,
      currentSectorRole: Object,
      currentProduct: null,
      productId: null,
      productLegalConsultationId: null,
      productHierarchyId: null,
      legalSearches: [],
      termsOfUseId: null,
      companyId: null,
      queryId: null,
      unitId: null,
      sectorsId: [],
      sectorId: null,
      sectorRoleId: null,
      sectorsRolesId: [],
      rolesId: [],
      productsId: [],
      roleId: null,
      legalsearchIds: null,
      companyLegalConsultation: null,
      company: {
        name: '',
        description: '',
        _id: null
      },
      pendencies: [],
      pendenciesSector: [],
      pendenciesRole: [],
      ventilationLevels: [],
      optionsVentilationIdentified: [],
      optionsExposureTime: [],
      optionsFrequencyUse: [],
      optionsQuantityUsed: [],
      physicalProductStates: [],
      optionsDegreeOfDust: [],
      lisProductsId: [],
      product: {},
      role: {},
      importTargetProduct: null,
      dateNewFormatCompanyHierarchy: new Date(),
      newCompanyHierarchyFormat: true,
      archivedRolesSectorId: null,
      model: LegalSearchSummary,
    }
  },
  async mounted() {
    try {
      Object.assign(this.ventilationLevels, ventilationLevels)
      this.ventilationLevels = ventilationLevels
      Object.assign(this.optionsVentilationIdentified, optionsVentilationIdentified)
      this.optionsVentilationIdentified = optionsVentilationIdentified
      Object.assign(this.optionsExposureTime, optionsExposureTime)
      this.optionsExposureTime = optionsExposureTime
      Object.assign(this.optionsFrequencyUse, optionsFrequencyUse)
      this.optionsFrequencyUse = optionsFrequencyUse
      Object.assign(this.optionsQuantityUsed, optionsQuantityUsed)
      this.optionsQuantityUsed = optionsQuantityUsed
      Object.assign(this.physicalProductStates, physicalProductStates)
      this.physicalProductStates = physicalProductStates
      Object.assign(this.optionsDegreeOfDust, optionsDegreeOfDust)
      this.optionsDegreeOfDust = optionsDegreeOfDust
      await this.getCompany()
      const { id } = this.$route.query
      if (id) {
        this.queryId = id
        document.getElementById(this.queryId).classList.add('pulse-gro')
        document.getElementById(this.queryId).scrollIntoView()
      }
    } catch (e) {
    }
  },
  async beforeDestroy() {
    await this.load()
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    ...mapGetters('companyLegalConsultation', {
      importedCompany: 'importedCompany'
    }),
    disabled() {
      return !(this.company.name && this.company.description)
    }
  },
  methods: {
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    ...mapActions('companyLegalConsultation', {
      handlePaginationCompanyLegalConsultation: 'handlePaginationCompanyLegalConsultation',
      handleGetByIdCompanyLegalConsultation: 'handleGetByIdCompanyLegalConsultation',
      handleUpdatecompanyLegalConsultation: 'handleUpdatecompanyLegalConsultation',
      handleDeletecompanyLegalConsultation: 'handleDeletecompanyLegalConsultation',
      handleUpdateOpencompanyLegalConsultation: 'handleUpdateOpencompanyLegalConsultation',
      handleGetCompleteHierarchyCompanyLegalConsultation: 'handleGetCompleteHierarchyCompanyLegalConsultation',
      handleOpenHierarchyCompleteCompanyLegalConsultation: 'handleOpenHierarchyCompleteCompanyLegalConsultation',
      handleClear: 'handleClear'
    }),
    ...mapActions('productLegalConsultation', {
      handleDeleteByIdProductLegalConsultation: 'handleDeleteByIdProductLegalConsultation'
    }),
    ...mapActions('unit', {
      handleOpen: 'handleOpen',
      handleDelete: 'handleDelete'
    }),
    ...mapActions('sector', {
      handleOpenSector: 'handleOpen',
      handleDeleteSector: 'handleDelete'
    }),
    ...mapActions('role', {
      handleOpenRole: 'handleOpen',
      handleDeleteRole: 'handleDelete',
      handleUpdateRiskOpenSectorRole: 'handleUpdateRiskOpenSectorRole',
      handleArchiveSectorRole: 'handleArchive'
    }),

    async toggleRiskOpen(sectorRole, riskField) {
      this.lookingForCompany = true
      if (!sectorRole || !sectorRole._id) return
      const newValue = !sectorRole[riskField]
      this.$set(sectorRole, riskField, newValue)
      await this.handleUpdateRiskOpenSectorRole({
        _id: sectorRole._id,
        [riskField]: newValue,
      })
      await this.getCompany()
      this.lookingForCompany = false
    },
    ...mapActions('permanentExhibition', {
      handleCreatePermanentExhibition: 'handleCreatePermanentExhibition',
      handleUpdatePermanentExhibition: 'handleUpdatePermanentExhibition',
      handleGetPermanentExhibition: 'handleGetPermanentExhibition',
      handleGetByProductPermanentExhibition: 'handleGetByProductPermanentExhibition',
      handleGetByProductHierarchyPermanentExhibition: 'handleGetByProductHierarchyPermanentExhibition',
      handleReset: 'handleReset',
    }),
    ...mapActions('effectiveProtection', {
      handleCreateEffectiveprotection: 'handleCreateEffectiveprotection',
      handleUpdateEffectiveprotection: 'handleUpdateEffectiveprotection',
      handleGetEffectiveprotection: 'handleGetEffectiveprotection',
      handleGetByProductEffectiveprotection: 'handleGetByProductEffectiveprotection',
      handleGetBySectorEffectiveprotection: 'handleGetBySectorEffectiveprotection',
      handleGetBySectorRoleEffectiveprotection: 'handleGetBySectorRoleEffectiveprotection',
      handleReset: 'handleReset'
    }),

    getRolesLegalsearches(sectorRole, risk){
      const {role} = sectorRole || {}
      const {rolesLegalsearches} = role || {}

      if(!rolesLegalsearches || rolesLegalsearches.length <= 0){
        return false
      }
      return rolesLegalsearches.filter(x => x.riskType == risk).length > 0
    },

    getAgentsByRisk(sectorRole, risk) {
      const {role} = sectorRole || {}
      const {rolesLegalsearches} = role || {}

      if(!rolesLegalsearches || rolesLegalsearches.length <= 0){
        return false
      }
      return rolesLegalsearches.filter(x => x.riskType == risk)
    },
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy')
    },
    async load() {
      await this.$store.dispatch('legalSearch/load', this.user.id)
    },

    async showEffectiveProtectionOrPermanentExhibition(product, functionality) {
      this.lookingForCompany = true;
      this.productId = product.productLegalConsultationId;
      this.productHierarchyId = product._id;
      this.functionalityProps = functionality;
      const { effectiveProtection } = await this.handleGetByProductEffectiveprotection(this.productId) || {}
      this.protecaoEficazProps = effectiveProtection
      const { permanentExhibition } = await this.handleGetByProductPermanentExhibition(this.productId) || {}
      this.exposicaoPermanenteProps = permanentExhibition
      this.userOrProduct = 'product';
      setTimeout(() => {
        this.$bvModal.show('effective-protection-modal')
        this.lookingForCompany = false;
      },100)
    },

    async showEffectiveProtection(sector, sectorId, sectorRoleId, event, questions) {
      event.stopPropagation()
      this.lookingForCompany = true;
      this.sectorId = sectorId;
      this.sectorRoleId = sectorRoleId;
      this.questions = questions;
      if (sectorId) {
        const { effectiveProtection } = await this.handleGetBySectorEffectiveprotection(this.sectorId) || {}
        this.protecaoEficazProps = effectiveProtection
      } else if (sectorRoleId) {
        const { effectiveProtection } = await this.handleGetBySectorRoleEffectiveprotection(this.sectorRoleId) || {}
        this.protecaoEficazProps = effectiveProtection
      }
      this.lookingForCompany = false;
      setTimeout(() => {
        this.$bvModal.show('effectiveProtection')
      },100)
    },

    async updateEffectiveprotection(protecaoEficaz) {
      this.disabledAnalysisTool = true;
      if (protecaoEficaz._id) {
        protecaoEficaz.tab = 'GRO'
        await this.handleUpdateEffectiveprotection(protecaoEficaz)
      } else {
        protecaoEficaz.tab = 'GRO'
        await this.handleCreateEffectiveprotection(protecaoEficaz)
        if(protecaoEficaz.sectorId) {
          const { effectiveProtection } = await this.handleGetBySectorEffectiveprotection(this.sectorId) || {}
          this.protecaoEficazProps = effectiveProtection
        }else if(protecaoEficaz.sectorRoleId) {
          const { effectiveProtection } = await this.handleGetBySectorRoleEffectiveprotection(this.sectorRoleId) || {}
          this.protecaoEficazProps = effectiveProtection
        }
      }
      this.disabledAnalysisTool = false;
    },

    async showPermanentExhibition(product, sector, event) {
      try {
        event.stopPropagation()
        this.lookingForCompany = true;
        const { _id: productHierarchyId, productLegalConsultationId, termsofuses } = product || {};
        const {_id: termsOfUseId} = termsofuses || {}
        const { _id: sectorId } = sector || {}
        this.productHierarchyId = productHierarchyId;
        this.productLegalConsultationId = productLegalConsultationId;
        this.termsOfUseId = termsOfUseId;
        this.sectorId = sectorId;
        this.exposicaoPermanenteProps = null
        const { permanentExhibition } = (await this.handleGetByProductHierarchyPermanentExhibition({
          productHierarchyId,
          termsOfUseId,
          sectorId,
          productLegalConsultationId
        })) || {}
        this.exposicaoPermanenteProps = permanentExhibition
        this.lookingForCompany = false;
        this.disabledAnalysisTool = false;
        setTimeout(() => {
          this.$bvModal.show('permanent-exhibition')
        },100)
      } catch (e) {
        this.lookingForCompany = false;
        this.disabledAnalysisTool = false;
        setTimeout(() => {
          this.$bvModal.show('permanent-exhibition')
        },100)
      }
    },

    async updatePermanentExhibition(exposicaoPermanente) {
      this.disabledAnalysisTool = true;
      if (exposicaoPermanente._id) {
        exposicaoPermanente.tab = 'GRO'
        await this.handleUpdatePermanentExhibition(exposicaoPermanente)
      } else {
        exposicaoPermanente.user = this.user.id
        exposicaoPermanente.tab = 'GRO'
        await this.handleCreatePermanentExhibition(exposicaoPermanente)
      }
      const { permanentExhibition } = (await this.handleGetByProductHierarchyPermanentExhibition({
        productHierarchyId: this.productHierarchyId,
        termsOfUseId: this.termsOfUseId,
        sectorId: this.sectorId,
        productLegalConsultationId: this.productLegalConsultationId
      })) || {}
      this.exposicaoPermanenteProps = permanentExhibition
      this.disabledAnalysisTool = false;
    },

    async completeHierarchy(productId){
      this.lookingForCompany = true;
      await this.handleOpenHierarchyCompleteCompanyLegalConsultation(this.importedCompany._id)
      this.lookingForCompany = false;
      await this.getCompany()
      const element = document.getElementById(this.queryId)
      if (element) {
        element.classList.remove('pulse-gro')
      }
      this.queryId = productId
      document.getElementById(this.queryId).classList.add('pulse-gro')
      document.getElementById(this.queryId).scrollIntoView()
    },

    async completeHierarchySector(productId){
      this.lookingForCompany = true;
      await this.handleOpenHierarchyCompleteCompanyLegalConsultation(this.importedCompany._id)
      this.lookingForCompany = false;
      await this.getCompany()
      const element = document.getElementById(this.queryId)
      if (element) {
        element.classList.remove('pulse-gro')
      }
      this.queryId = productId
      document.getElementById(this.queryId).classList.add('pulse-gro')
      document.getElementById(this.queryId).scrollIntoView()
    },

    async showModalEditCompany(company, event) {
      try {
        event.stopPropagation()
        this.$refs.companyUpdate.show()
        this.lookingForCompany = true
        this.loading = false
        const { data } = await this.handleGetByIdCompanyLegalConsultation(
          company._id
        )
        this.lookingForCompany = false
        this.company = data.company
        this.currentCompany = company
      } catch (e) {
      }
    },

    processProductBacklog() {
      try {
        this.pendencies = []
        this.pendenciesSector = []
        this.pendenciesRole = []
        this.companyLegalConsultation.units.forEach(unit => {
          unit.sectors.forEach((sector) => {
            const notFilledIn = []
            if(!sector.ventilationWorkEnvironmentGeneral){
              notFilledIn.push('Condição de ventilação do ambiente de trabalho de forma geral')
            }

            if(!sector.effectiveProtection || !(sector.effectiveProtection && sector.effectiveProtection._id && this.analysisPermanentExposureAndEffectiveProtection.interactedEffectiveProtectionQuestionsPergunta_1_existeEquipamentoProtecaoColetivaAuxiliarControleRiscoQuimico(sector.effectiveProtection))){
              notFilledIn.push('Proteção eficaz')
            }
            if(notFilledIn.length > 0) {
              this.pendenciesSector.push(
                {
                  sectorId: sector._id,
                  sector: sector.name,
                  fieldsNotFilledIn: notFilledIn
                }
              )
            }

            sector.sectorRoles.forEach((sectorRole) => {
              if (sectorRole.role) {
                const notFilledIn = []
                if(!sectorRole.exposedWorkers){
                  notFilledIn.push('Quantidade de trabalhadores expostos')
                }
                if(!sectorRole.noMeasurementsWillBeTaken && (sectorRole.measurements.length <= 0)){
                  notFilledIn.push('Medições')
                }
                if(!sectorRole.effectiveProtection || !(sectorRole.effectiveProtection && sectorRole.effectiveProtection._id && this.analysisPermanentExposureAndEffectiveProtection.interactedEffectiveProtectionQuestionsPergunta_2_empregadorOrganizacaoCumpreFazCumprirItensNR06TopicoPergunta_3_empregadoTrabalhadorCumpreTodosItensNR06Topico66(sectorRole.effectiveProtection))){
                  notFilledIn.push('Proteção eficaz')
                }
                if(notFilledIn.length > 0) {
                  this.pendenciesRole.push(
                    {
                      sectorRoleId: sectorRole._id,
                      sectorRole: sectorRole.role.name,
                      fieldsNotFilledIn: notFilledIn
                    }
                  )
                }
                if (sectorRole.role && sectorRole.role.roleProductsLegalConsultation && sectorRole.role.roleProductsLegalConsultation.length > 0) {
                  sectorRole.role.roleProductsLegalConsultation.forEach((roleProductLegalConsultation) => {
                    if(roleProductLegalConsultation.product && roleProductLegalConsultation.product._id) {
                      const { product } = roleProductLegalConsultation || {}
                      const { permanentExhibition } = product || {}
                      const notFilledIn = []
                      if(permanentExhibition && permanentExhibition._id){
                        const {
                          exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao,
                          foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente,
                          frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade,
                          trabalhadorexecutaAtividadeAgentesQuimicosAnalisados,
                        } = permanentExhibition

                        if(exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao == null){
                          notFilledIn.push('Exposição permanente: A exposição ao agente químico ocorre de forma indissociável da função?')
                        }

                        if(foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente == null){
                          notFilledIn.push('Exposição permanente: Foram identificadas todas as fontes e formas como o produto é liberado no ar ou no ambiente?')
                        }

                        if(frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade == null){
                          notFilledIn.push('Exposição permanente: A frequência em que o trabalhador realiza a atividade é previsível?')
                        }

                        if(trabalhadorexecutaAtividadeAgentesQuimicosAnalisados == null){
                          notFilledIn.push('Exposição permanente:  O trabalhador tem contato dermal e/ou respiratório ou até outra que possa trazer algum dano a sua saúde?')
                        }
                      } else {
                        notFilledIn.push('Exposição permanente')
                      }

                      if (!product.termsofuses || !product.termsofuses.quantityUsed) {
                        notFilledIn.push('Quantidade diária utilizada deste produto')
                      }

                      if (!product.termsofuses || !product.termsofuses.frequencyUse) {
                        notFilledIn.push('Frequência diária de utilização deste produt')
                      }

                      if (!product.termsofuses || !product.termsofuses.exposureTime) {
                        notFilledIn.push('Tempo de exposição (do trabalhador com o uso do produto')
                      }

                      if (roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.permanentExhibition && roleProductLegalConsultation.product.permanentExhibition._id) {
                        const { product } = roleProductLegalConsultation
                        const { permanentExhibition } = product
                      }

                      for (const legalSearch of product.legalSearches) {
                        if(!legalSearch.percentage || legalSearch.percentage <= 0) {
                          notFilledIn.push(`% do agente: ${legalSearch.name}`)
                        }
                      }

                      if (!product.termsofuses || !product.termsofuses.ventilationInstalledSpecificallyForTheProductionProcess) {
                        notFilledIn.push('Condição de ventilação instalada e específica para o processo produtivo')
                      }

                      if (!product.termsofuses || !product.termsofuses.temperature) {
                        notFilledIn.push('Temperatura (em ºC - graus Celsius) de uso do produto')
                      }
                      if(notFilledIn.length > 0) {
                        this.pendencies.push(
                          {
                            productId: product._id,
                            product: product.name,
                            fieldsNotFilledIn: notFilledIn
                          }
                        )
                        }
                    }
                  })
                }
              }
            })
          })
        })
      } catch (e) {

      }
    },

    /*Inicio funcionalidade unidade*/
    async showModalUnit(company, event) {
      try {
        event.stopPropagation()
        this.companyId = company._id
        this.unitId = null
        setTimeout(() => {
          this.$bvModal.show('unit')
        }, 100)
      } catch (e) {
      }
    },

    async showModalUpdateUnit(unit, event) {
      try {
        event.stopPropagation()
        this.companyId = unit.company
        this.unitId = unit._id
        setTimeout(() => {
          this.$bvModal.show('unit')
        }, 100)
      } catch (e) {
      }
    },

    async showModalDeleteUnit(unit, event) {
      try {
        const {_id: unitId, sectors } = unit
        this.unitId = unitId
        this.sectorsId = []
        this.sectorsRolesId = []
        this.rolesId = []
        this.productsId = []
        if(sectors && sectors.length > 0){
          sectors.forEach((sector) => {
            this.sectorsId.push(sector._id)
            const { sectorRoles } = sector
            if(sectorRoles && sectorRoles.length > 0){
              sectorRoles.forEach((sectorRole) => {
                this.sectorsRolesId.push(sectorRole._id)
                if(sectorRole.role && sectorRole.role._id){
                  const { roleProductsLegalConsultation } = sectorRole.role
                  this.rolesId.push(sectorRole.role._id)
                  if (roleProductsLegalConsultation && roleProductsLegalConsultation.length > 0){
                    roleProductsLegalConsultation.forEach((roleProductLegalConsultation) => {
                      const { product } = roleProductLegalConsultation
                      if (product && product._id){
                        this.productsId.push(product._id)
                      }
                    })
                  }
                }
              })
            }
          })
        }

        event.stopPropagation()
        this.$bvModal.show('deleteUnit')
        this.titleRemove = `Excluir unidade`
        this.descriptionRemove = `Essa ação vai excluir a unidade <strong>${unit.name}</strong>.<br/> deseja realmente finalizar esta ação?`
        this.currentUnit = unit
      } catch (e) {
      }
    },

    async deleteUnit() {
      try {
        this.loadingRemove = true
        const { data, status } = await this.handleDelete({
          unitId: this.unitId,
          sectorsId: this.sectorsId,
          sectorsRolesId: this.sectorsRolesId,
          rolesId: this.rolesId,
          productsId: this.productsId,
          userId: this.user.id,
        })
        this.loadingRemove = false
        this.$bvModal.hide('deleteUnit')
        let message = data.message
        let variant = 'success'
        if (status !== 200) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        await this.getCompany()
      } catch (e) {
      }
    },

    async detailUnit(unit) {
      try {
        this.lookingForCompany = true
        await this.handleOpen(unit)
        await this.getCompany()
        this.lookingForCompany = false
      } catch (e) {
      }
    },
    /*Fim funcionalidade unidade*/


    /*Inicio funcionalidade setor*/
    async showModalSector(unit, event) {
      try {
        event.stopPropagation()
        this.unitId = unit._id
        this.sectorId = null
        setTimeout(() => {
          this.$bvModal.show('sector')
        }, 100)
      } catch (e) {
      }
    },

    async showModalUpdateSector(sector, event) {
      try {
        event.stopPropagation()
        this.unitId = sector.unit
        this.sectorId = sector._id
        setTimeout(() => {
          this.$bvModal.show('sector')
        }, 100)
      } catch (e) {
      }
    },

    async showModalDeleteSector(sector, event) {
      try {
        const { _id: sectorId, sectorRoles } = sector
        this.sectorId = sectorId
        this.sectorsRolesId = []
        this.rolesId = []
        this.productsId = []
        if(sectorRoles && sectorRoles.length > 0){
          sectorRoles.forEach((sectorRole) => {
            this.sectorsRolesId.push(sectorRole._id)
            if(sectorRole.role && sectorRole.role._id){
              const { roleProductsLegalConsultation } = sectorRole.role
              this.rolesId.push(sectorRole.role._id)
              if (roleProductsLegalConsultation && roleProductsLegalConsultation.length > 0){
                roleProductsLegalConsultation.forEach((roleProductLegalConsultation) => {
                  const { product } = roleProductLegalConsultation
                  if (product && product._id){
                    this.productsId.push(product._id)
                  }
                })
              }
            }
          })
        }
        event.stopPropagation()
        this.$bvModal.show('deleteSector')
        this.titleRemove = `Excluir setor`
        this.descriptionRemove = `Essa ação vai excluir o setor <strong>${sector.name}</strong>.<br/> deseja realmente finalizar esta ação?`
        this.currentSector = sector
      } catch (e) {
      }
    },

    async deleteSector() {
      try {
        this.loadingRemove = true
        const { data, status } = await this.handleDeleteSector({
          sectorId: this.sectorId,
          sectorsRolesId: this.sectorsRolesId,
          rolesId: this.rolesId,
          productsId: this.productsId,
        })
        this.loadingRemove = false
        this.$bvModal.hide('deleteSector')
        let message = data.message
        let variant = 'success'
        if (status !== 200) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        await this.getCompany()
      } catch (e) {
      }
    },

    async detailSector(sector) {
      try {
        this.lookingForCompany = true
        await this.handleOpenSector(sector)
        await this.getCompany()
        this.lookingForCompany = false
      } catch (e) {
      }
    },
    /*Fim funcionalidade setor*/


    /*Inicio funcionalidade cargo*/
    async showModalSelectRoles(sector, event) {
      try {
        event.stopPropagation()
        this.sectorId = sector._id
        setTimeout(() => {
          this.$bvModal.show('selectRoles')
        }, 100)
      } catch (e) {
      }
    },

    async showModalArchivedRoles(sector, event) {
      try {
        event.stopPropagation()
        this.archivedRolesSectorId = sector._id
        setTimeout(() => {
          this.$bvModal.show('archivedRoles')
        }, 100)
      } catch (e) {
      }
    },

    async showModalRole(sector, event) {
      try {
        event.stopPropagation()
        this.sectorId = sector._id
        this.roleId = null
        setTimeout(() => {
          this.$bvModal.show('role')
        }, 100)
      } catch (e) {
      }
    },

    async showModalUpdateRole(role, event) {
      try {
        event.stopPropagation()
        this.sectorId = role.sector
        this.roleId = role._id
        setTimeout(() => {
          this.$bvModal.show('role')
        }, 100)
      } catch (e) {
      }
    },

    async showModalArchiveRole(sectorRole, unit, sector, event) {
      try {
        event.stopPropagation()
        const { role, _id: sectorRoleId } = sectorRole
        this.sectorRoleId = sectorRoleId
        this.roleId = role._id
        this.currentRole = role
        this.currentSectorRole = sectorRole
        this.$bvModal.show('archiveRole')
        this.titleRemove = `Arquivar cargo`
        this.descriptionRemove = `<strong>Setor:</strong> ${sector.name}<br/><br/>Essa ação vai arquivar o cargo <strong>${role.name}</strong> e as informações dele neste setor.<br/><br/>Ele deixará de ser mostrado nas abas GRO, Laudo de insalubridade, Limites prevencionistas, LTCAT e PCMSO. Você poderá desarquivá-lo depois.<br/><br/>Deseja realmente finalizar esta ação?`
      } catch (e) {
      }
    },

    async archiveRole() {
      try {
        this.loadingRemove = true
        const { data, status } = await this.handleArchiveSectorRole(this.sectorRoleId)
        this.loadingRemove = false
        this.$bvModal.hide('archiveRole')
        let message = data.message
        let variant = 'success'
        if (status !== 200) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        await this.getCompany()
      } catch (e) {
      }
    },

    async detailRole(sectroRole) {
      try {
        this.lookingForCompany = true
        await this.handleOpenRole(sectroRole._id)
        await this.getCompany()
        this.lookingForCompany = false
      } catch (e) {
      }
    },
    /*Fim funcionalidade cargp*/

    /*Inicio funcionalidade condições de uso*/
    async showModalTermsOfUse(product) {
      try {
        this.productId = product._id
        this.termsOfUseId = null
        setTimeout(() => {
          this.$bvModal.show('termsOfUse')
        }, 100)
      } catch (e) {
      }
    },

    async showWorkersModal(product, modalRef) {
      try {
        this.productId = product.productLegalConsultationId
        this.productHierarchyId = product._id
        this.termsOfUseId = product && product.termsofuses && product.termsofuses._id ? product.termsofuses._id : null
        setTimeout(() => {
          this.$bvModal.show(modalRef)
        }, 100)
      } catch (e) {
      }
    },

    async showModalCentilationWorkEnvironmentGeneral(sector, event) {
      try {
        event.stopPropagation()
        this.sectorId = sector._id
        setTimeout(() => {
          this.$bvModal.show('ventilationIdentifiedModal')
        }, 100)
      } catch (e) {
      }
    },

    async showModalExposedWorkers(sectorRole, event) {
      try {
        event.stopPropagation()
        this.sectorRoleId = sectorRole._id
        setTimeout(() => {
          this.$bvModal.show('workersModal')
        }, 100)
      } catch (e) {
      }
    },

    async showUnlinkProductModal(product, role) {
      try {
        this.product = product
        this.role = role
        setTimeout(() => {
          this.$bvModal.show('unlinkProductModal')
        }, 100)
      } catch (e) {
      }
    },

    async showModalUpdateTermsOfUse(termsOfUse) {
      try {
        this.termsOfUseId = termsOfUse._id
        setTimeout(() => {
          this.$bvModal.show('termsOfUse')
        }, 100)
      } catch (e) {
      }
    },

    async showImportTermsOfUse(product) {
      try {
        this.importTargetProduct = product
        setTimeout(() => {
          this.$bvModal.show('importTermsOfUse')
        }, 100)
      } catch (e) {
      }
    },
    /*FIm funcionalidade condições de uso*/

    /*Inicio funcionalidade produto*/
    async showModalProducts(sectorRole, event) {
      try {
        const {role} = sectorRole || {}
        const {rolesLegalsearches} = role || {}
        console.log(sectorRole)
        event.stopPropagation()
        this.legalsearchIds = rolesLegalsearches && rolesLegalsearches.length > 0 ? rolesLegalsearches.map((x) => x.legalSearchId) : []
        this.roleId = sectorRole.role._id
        this.sectorId = sectorRole.sectorId
        this.sectorRoleId = sectorRole._id
        this.lisProductsId = sectorRole.role && sectorRole.role.roleProductsLegalConsultation && sectorRole.role.roleProductsLegalConsultation.length > 0
          ? sectorRole.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id).map((x) => x.productLegalConsultationId)
          : []
        setTimeout(() => {
          this.$bvModal.show('products')
        }, 100)
      } catch (e) {
        console.log(e)
      }
    },

    async showModalEditProduct(productId) {
      try {
        eventBus.$emit('showModalAddProduct', { productId })
      } catch (e) {
      }
    },

    async showModalEditMeasurements(sectorRole, event) {
      try {
        event.stopPropagation()
        this.sectorRoleId = sectorRole._id
        const { role } = sectorRole
        const { roleProductsLegalConsultation } = role
        this.legalSearches = []
        roleProductsLegalConsultation.forEach((x, index) => {
          if(x.product && x.product.legalSearches && x.product.legalSearches.length > 0) {
            const legalSearches = x.product.legalSearches.map((legalSearch, index) => {
              return {
                productId: x.productLegalConsultationId,
                productHierarchyId: x.product._id,
                legalSearch,
                _id: index + 1
              }
            })
            this.legalSearches.push(...legalSearches)
          }
        })
        setTimeout(() => {
          this.$bvModal.show('measurementsModal')
        }, 100)
      } catch (e) {
        console.log('e')
        console.log(e)
        console.log('e')
      }
    },
    /*Fim funcionalidade produto*/


    /*Inicio funcionalidade Empresa*/
    async update() {
      try {
        this.loading = true
        const { data, status } =
          await this.handleUpdatecompanyLegalConsultation(this.company)
        this.loading = false
        this.hideModalCompanyUpdate()
        await this.getCompany()
        let message = data.message
        let variant = 'success'
        if (status !== 200) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
      } catch (e) {
      }
    },

    async getCompany() {
      try {
        this.productId = null
        this.lookingForCompany = true
        const { data, status } = await this.handleGetCompleteHierarchyCompanyLegalConsultation({ id: this.importedCompany._id, filterArchived: true })
        if (status === 200) {
          const { company } = data
          this.companyLegalConsultation = company
        }
        this.dateNewFormatCompanyHierarchy = new Date(process.env.VUE_APP_DATE_NEW_FORMAT_COMPANY_HIERARCHY)
        this.newCompanyHierarchyFormat = moment(new Date(this.companyLegalConsultation.createdAt)).isSameOrAfter(moment(this.dateNewFormatCompanyHierarchy))
        this.processProductBacklog()
        const element = document.getElementById(this.queryId)

        if (element) {
          element.classList.remove('pulse-gro')
          this.queryId = null
          const { id } = this.$route.query
          if (id) {
            await this.$router.push('/web')
          }
        }
        this.lookingForCompany = false
      } catch (e) {
      }
    },

    hideModalCompanyUpdate() {
      this.$refs.companyUpdate.hide()
    },

    async detailCompany(company) {
      try {
        this.lookingForCompany = true
        await this.handleUpdateOpencompanyLegalConsultation(company)
        await this.getCompany()
        this.lookingForCompany = false
      } catch (e) {
      }
    },
    /*Inicio funcionalidade Empres*/

    async showModalAgentPercentage(product) {
      try {
        this.productId = product.productLegalConsultationId
        setTimeout(() => {
          this.$bvModal.show('agentPercentage')
        }, 100)
      } catch (e) {
      }
    }
  },
  created() {
    const breadcrumb = {
      tab: 'gro',
      page: 'Consulta Legal',
      subPage: {
        name: 'Consulta Legal',
        active: false
      },
      tabs: [
        {
          name: 'Gerenciamento de Riscos Ocupacionais',
          active: true
        }
      ]
    }
    this.setBreadcrumb(breadcrumb)
  }
}
</script>
<style lang='scss' scoped>

.pulse-gro-chevron-up {
  -webkit-animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  box-shadow: 0 0 0 0 #ed9121;
  border-radius: 4px;
  margin-bottom: 4px!important;
  margin-top: 4px!important;
}

.pulse-gro {
  -webkit-animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  box-shadow: 0 0 0 0 #bc0000;
  border-radius: 4px;
  margin-bottom: 4px!important;
  margin-top: 4px!important;
}

@-webkit-keyframes pulse-gro {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@-moz-keyframes pulse-gro {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@-ms-keyframes pulse-gro {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@keyframes pulse-gro {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

.body {
  width: 100%;
  border-radius: 4px;
  background: #F3F3F4;
  margin-bottom: 1px !important;

  .description-title {
    color: #808080;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .description-text {
    color: #808080;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}

.description-title {
  color: #808080;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.description-text {
  color: #808080;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.loading-spinner {
  margin-top: 250px;
}

.rotate {
  transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}

.transition {
  -webkit-transition: -webkit-transform 0.5s ease-in-out;
  -ms-transition: -ms-transform 0.5s ease-in-out;
  transition: transform 0.5s ease-in-out;
}

.btn-product-action {
  border-radius: 3px;
  border: 1px solid #808080;
  background: #fff;
  padding: 2px;
  width: 40px;
  height: 40px;
}

.btn-cancel {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.main-title {
  color: #262626;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.company {
  background: #262626;
  border-radius: 4px 4px 0px 0px;
  min-height: 60px;
  cursor: pointer;

  .name {
    color: #FFFFFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    text-align: center;
  }

  .btn-options {
    border-radius: 5px !important;
    border: 2px solid #FFFFFF !important;
    background: transparent !important;
    width: 100px !important;
    text-align: center !important;
  }

  .options {
    border-radius: 8px !important;
    width: 230px !important;
  }

  .btn-options-text {
    color: #FFFFFF !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 700 !important;
  }
}

.unit {
  //margin-left: 25px;
  background: #022245;
  min-height: 60px;
  margin-top: 1px;
  cursor: pointer;

  .name {
    color: #FFFFFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    text-align: center;
  }

  .btn-options {
    border-radius: 5px !important;
    border: 2px solid #FFFFFF !important;
    background: transparent !important;
    width: 100px !important;
    text-align: center !important;
  }

  .options {
    border-radius: 8px !important;
    width: 220px !important;
  }

  .btn-options-text {
    color: #FFFFFF !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 700 !important;
  }
}

.sector {
  background: #04A8F3 !important;
  //margin-left: 50px !important;
  margin-top: 1px !important;
  min-height: 60px !important;
  cursor: pointer !important;

  .name {
    color: #FFFFFF !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 700 !important;
    text-align: center !important;
  }

  .btn-options {
    border-radius: 5px !important;
    border: 2px solid #FFFFFF !important;
    background: transparent !important;
    width: 100px !important;
    text-align: center !important;
  }

  .options {
    border-radius: 8px !important;
    width: 220px !important;
  }

  .btn-options-text {
    color: #FFFFFF !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 700 !important;
  }
}

.role {
  background: #BDEAFF !important;
  min-height: 60px !important;
  margin-top: 1px !important;
  //margin-left: 75px !important;
  cursor: pointer !important;

  .name {
    color: var(--navy-blue) !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 700 !important;
    text-align: center !important;
  }

  .btn-options {
    border-radius: 5px !important;
    border: 2px solid var(--navy-blue) !important;
    background: transparent !important;
    width: 100px !important;
    text-align: center !important;
  }

  .options {
    border-radius: 8px !important;
    width: 220px !important;
  }

  .btn-options-text {
    color: var(--navy-blue) !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 700 !important;
  }
}

.product {
  min-height: 60px;
  margin-top: 1px;
  margin-bottom: 2px;

  .name {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    text-align: center;
  }

  .btn-options {
    border-radius: 5px !important;
    border: 2px solid var(--navy-blue);;
    background: transparent !important;
    width: 100px;
    text-align: center;
  }

  .options {
    border-radius: 8px !important;
    width: 290px !important;
  }

  .btn-options-text {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }

  .btn-product {
    border-radius: 5px !important;
    border: 2px solid var(--navy-blue);
    background: transparent;
    padding: 7px 5px;
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }
}

.body-hierarchy {
  border-radius: 0 0 4px 4px;
  border: 1px solid #04A8F3;
  background: var(--Azul-Claro-10, rgba(4, 168, 243, 0.10));
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    border: 2px solid #022245!important;
    padding: 8px 10px!important;
    background: transparent!important;
    border-radius: 5px!important;
    display: flex!important;
    align-items: center!important;
    justify-content: space-between!important;
    margin: 10px 5px!important;
    .body-hierarchy-icon {
      color: #022245!important;
    }
    &:hover{
      background: #022245!important;
      span, .body-hierarchy-icon{
        color: #FFFFFF!important;
      }
    }
  }

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding-bottom: 2px !important;
    margin-left: 10px;
  }
}

hr {
  margin-top: 0 !important;
  background: #c0c0c0;
}

.title-product {
  color: #808080;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
  letter-spacing: 0.28px;
}

.header-product {
  width: 16% !important;
  word-break: break-word;
}

.header-product-actions {
  width: 20% !important;
  word-break: break-word;
  text-align: center!important;
}

.body-product {
  width: 16% !important;
  word-break: break-word;
}

.body-product-actions {
  width: 20% !important;
  word-break: break-word;
  height: max-content !important;
  text-align: center!important;
}

.text-data-product {
  color: #808080;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

h3 {
  color: #262626;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
}

.btn-cations {
  height: 50px !important;
  min-width: 50px !important;
  font-size: 15px;
}

.btn-termsofuses {
  border-radius: 5px;
  background: #FFFFFF !important;
  border: 1.5px solid #022245 !important;
  height: 44px !important;
  width: 44px !important;
  margin: 2.5px !important;
  padding: 6px !important;

  svg {
    path {
      fill: var(--navy-blue) !important;
    }
  }
  .btn-icon{
    color: var(--navy-blue) !important;
  }
  &:hover {
    background: var(--navy-blue) !important;

    svg {
      path {
        fill: #FFFFFF !important;
      }
    }
  }
}

.termsofuses-actions {
  background: #02224580;
  border-radius: 10px;
  padding: 2px 4px;
}

.btn-import-termsofuses {
  border-radius: 50%;
  background: var(--navy-blue) !important;
  border: 1.5px solid var(--navy-blue) !important;
  height: 30px !important;
  width: 30px !important;
  margin: 2.5px !important;
  padding: 6px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    path {
      fill: #04A8F3 !important;
    }
  }
  &:hover {
    background: #011a36 !important;
    border-color: #011a36 !important;

    svg {
      path {
        fill: #FFFFFF !important;
      }
    }
  }
}

.btn-termsofuses-not-filled {
  border-radius: 5px;
  background: #FFFFFF !important;
  border: 1.5px solid #CD0000 !important;
  height: 44px !important;
  width: 44px !important;
  margin: 2.5px !important;
  padding: 6px !important;

  svg {
    path {
      fill: #CD0000 !important;
    }
  }

  &:hover {
    background: #CD0000 !important;

    svg {
      path {
        fill: #FFFFFF !important;
      }
    }
  }
}

.container-pendencies {
  border-radius: 4px;
  border: 1px solid #CD0000;
  background: rgba(205, 0, 0, 0.05);

  .item {
    color: #CD0000;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
  }
}

.btn-completed-permanent-exhibition {
  border-radius: 5px;
  background: #FFFFFF!important;
  border: 1.5px solid #022245 !important;
  height: 44px !important;
  width: 44px !important;
  margin: 2.5px !important;
  padding: 6px !important;
  text-align: center;
  .image-permanent-exhibition{
    background-image: url("../../../assets/images/protecaoEficazAzul.svg");
    background-repeat: no-repeat;
    background-position: center ;
    background-size: 30px ;
    height: 30px!important;
    width: 30px!important;
  }
  &:hover{
    background: #022245!important;
    .image-permanent-exhibition{
      background-image: url("../../../assets/images/protecaoEficazBranco.svg");
    }
  }
}

.btn-permanent-exhibition-without-filling {
  border-radius: 5px;
  background: #FFFFFF!important;
  border: 1.5px solid #CD0000 !important;
  height: 44px !important;
  width: 44px !important;
  margin: 2.5px !important;
  padding: 6px !important;
  text-align: center;
  .image-permanent-exhibition{
    background-image: url("../../../assets/images/protecaoEficazVermelho.svg");
    background-repeat: no-repeat;
    background-position: center ;
    background-size: 30px ;
    height: 30px!important;
    width: 30px!important;
  }
  &:hover{
    background: #CD0000!important;
    .image-permanent-exhibition{
      background-image: url("../../../assets/images/protecaoEficazBranco.svg");
    }
  }
}


.btn-completed-effective-protection {
  border-radius: 5px;
  background: #FFFFFF!important;
  border: 1.5px solid #022245 !important;
  height: 44px !important;
  width: 44px !important;
  margin: 2.5px !important;
  padding: 6px !important;
  text-align: center;
  .image-effective-protection{
    background-image: url("../../../assets/images/exposicaoPermanenteAzul.svg");
    background-repeat: no-repeat;
    background-position: center ;
    background-size: 30px ;
    height: 30px!important;
    width: 30px!important;
  }
  &:hover{
    background: #022245!important;
    .image-effective-protection{
      background-image: url("../../../assets/images/exposicaoPermanenteAzulBranco.svg");
    }
  }
}

.btn-effective-protection-without-filling {
  border-radius: 5px;
  background: #FFFFFF!important;
  border: 1.5px solid #CD0000 !important;
  height: 44px !important;
  width: 44px !important;
  margin: 2.5px !important;
  padding: 6px !important;
  text-align: center;
  .image-effective-protection{
    background-image: url("../../../assets/images/exposicaoPermanenteVermelho.svg");
    background-repeat: no-repeat;
    background-position: center ;
    background-size: 30px ;
    height: 30px!important;
    width: 30px!important;
  }
  &:hover{
    background: #CD0000!important;
    .image-effective-protection{
      background-image: url("../../../assets/images/exposicaoPermanenteAzulBranco.svg");
    }
  }
}


.btn-completed-effective-protection-sector {
  border-radius: 5px;
  background: #FFFFFF!important;
  border: 1.5px solid #022245 !important;
  height: 44px !important;
  width: 44px !important;
  margin: 2.5px !important;
  padding: 6px !important;
  text-align: center;
  .image-effective-protection{
    background-image: url("../../../assets/images/effective-protection-sector-azul.svg");
    background-repeat: no-repeat;
    background-position: center ;
    background-size: 30px ;
    height: 30px!important;
    width: 30px!important;
  }
  &:hover{
    background: #022245!important;
    .image-effective-protection{
      background-image: url("../../../assets/images/effective-protection-sector-azulBranco.svg");
    }
  }
}

.btn-completed-effective-protection-sector-without-filling {
  border-radius: 5px;
  background: #FFFFFF!important;
  border: 1.5px solid #CD0000 !important;
  height: 44px !important;
  width: 44px !important;
  margin: 2.5px !important;
  padding: 6px !important;
  text-align: center;
  .image-effective-protection{
    background-image: url("../../../assets/images/effective-protection-sector-vermelho.svg");
    background-repeat: no-repeat;
    background-position: center ;
    background-size: 30px ;
    height: 30px!important;
    width: 30px!important;
  }
  &:hover{
    background: #CD0000!important;
    .image-effective-protection{
      background-image: url("../../../assets/images/effective-protection-sector-azulBranco.svg");
    }
  }
}

.btn-unlink-product{
  border-radius: 4px;
  border: 2px solid #262626;
  background: transparent;
  padding: 5px 10px;
  span{
    font-weight: 700;
    font-size: 16px;
    color: #262626;
  }
}
.product-content{
  .header{
    box-shadow: 0px 0px 2px 2px #EDEDED;
    width: 100%;
    span{
      font-weight: 600;
      font-size: 17px;
      color: #262626;
    }
   }
  .percentage_produto-cas_agent{
    width: 50%!important;
    max-height: 300px;
    overflow-y : scroll;
    overflow-x : hidden;
  }
  .detalhes-produto{
    width: 50%!important;
    max-height: 300px;
    overflow-y : scroll;
    overflow-x : hidden;
  }

}
.altert-content {
  border: 1px solid #CD0000;
  background: rgba(205, 0, 0, 0.05);
  border-radius: 5px;
}
.btn-expand-collapse-white{
  border-radius: 7px!important;
  background: transparent;
  color: #FFFFFF;
  padding: 7px 10px;
  border: 2px solid #FFFFFF;
  font-weight: 700;
}
.btn-expand-collapse-navy-blue{
  border-radius: 7px!important;
  background: transparent;
  color: var(--navy-blue);
  padding: 7px 10px;
  border: 2px solid var(--navy-blue);
  font-weight: 700;
}
.risk-chemical{
  margin-top: 1px;
  background: #94D5F3;
  min-height: 60px;
  margin-left: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .risk-chemical-text{
    font-size: 18px!important;
    color: #262626!important;
    font-weight: 700!important;
  }
}
.risk-physical{
  background: #CCE5D2;
  min-height: 60px;
  margin-left: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .risk-physical-text{
    font-size: 18px!important;
    color: #262626!important;
    font-weight: 700!important;
  }
}
.risk-biological{
  background: #E3BEB0;
  min-height: 60px;
  margin-left: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .risk-biological-text{
    font-size: 18px!important;
    color: #262626!important;
    font-weight: 700!important;
  }
}
.physical-agents-header {
  background: #CCE5D2;
  th {
    color: #022245;
    font-weight: 700;
    vertical-align: middle;
  }
}
.biological-agents-header {
  background: #E3BEB0;
  th {
    color: #022245;
    font-weight: 700;
    vertical-align: middle;
  }
}
</style>
